import { Auth } from "./auth.js";
import { escapeHtml } from "./utils.js";
/**
 * Efast 工作台 - 票据中心
 * 侧边栏可折叠数据管理 + 右侧统一表单
 */

// ===== localStorage keys =====
var IK = { headers:'efast_headers', payments:'efast_payments', products:'efast_products', customers:'efast_customers', termsPayment:'efast_terms_payment', termsShipping:'efast_terms_shipping', termsMethods:'efast_terms_methods', termsCurrencies:'efast_terms_currencies', exchangeRate:'efast_exchange_rate', productImages:'efast_product_images', paymentImages:'efast_payment_images' };
var _serverProducts = null;
var DIF = { headers:[{name:"Shenzhen Efast Technology Co., Ltd.",company_name:"Shenzhen Efast Technology Co., Ltd.",contact:"Contact person:Samson Qiu\nEmail: samson@efast-tech.com\nMobile/WeChat/WhatsApp/Skype: +86 13560723375",manufacturer_info:"Company Name:Shenzhen Efast Technology Co., Ltd.\nAddress: Room Address: D270, No.64 Dalang South Road, Longhua District, Shenzhen 518110, Guangdong, China\nTel: 0086-13560723375",shipper:"Samson Qiu",ship_phone:"+86 13560723375",ship_address:"Room D270, No.64 Dalang South Road, Longhua District, Shenzhen 518110, Guangdong, China"}], payments:[{name:"HSBC Hong Kong Account",text:"Beneficiary Bank: HSBC Hong Kong\nAccount Name: Shenzhen Efast Technology Co., Ltd.\nAccount Number: 123-456789-001\nSwift Code: HSBCKHHX",image_path:""}], products:[], termsPayment:["100% payment in advance","20% deposit, 80% balance before shipment","30% deposit and 70% balance before shipment","50% deposit and 50% balance before shipment."], termsShipping:["EXW","FOB","CIF","DAP","DDP"], termsMethods:["Air","Sea","Land","Express","Post","Self-Collection"], termsCurrencies:["USD","RMB","EUR","CNY","HKD","GBP"], exchangeRate:{exchange_rate:7.1} };

function iload(k){ try{var r=localStorage.getItem(k);return r?JSON.parse(r):null;}catch(e){return null;} }
function isave(k,d){ localStorage.setItem(k,JSON.stringify(d)); }
function iget(k,def){ var d=iload(k);if(d===null||d===undefined){d=typeof def==='function'?def():JSON.parse(JSON.stringify(def));isave(k,d);}return d; }

var ih=function(){return iget(IK.headers,DIF.headers);}, ipa=function(){return iget(IK.payments,DIF.payments);}, ipr=function(){return iget(IK.products,DIF.products);}, icu=function(){return getCrmCustomersForDropdown();}, itp=function(){return iget(IK.termsPayment,DIF.termsPayment);}, its=function(){return iget(IK.termsShipping,DIF.termsShipping);}, itm=function(){return iget(IK.termsMethods,DIF.termsMethods);}, itc=function(){return iget(IK.termsCurrencies,DIF.termsCurrencies);}, ier=function(){return iget(IK.exchangeRate,DIF.exchangeRate);}, ib=function(){return Auth.getRole()==='boss';};

function syncSettingsToServer() {
    var data = {};
    data.headers = iload(IK.headers);
    data.payments = iload(IK.payments);
    data.products = iload(IK.products);
    data.termsPayment = iload(IK.termsPayment);
    data.termsShipping = iload(IK.termsShipping);
    data.termsMethods = iload(IK.termsMethods);
    data.termsCurrencies = iload(IK.termsCurrencies);
    data.exchangeRate = iload(IK.exchangeRate);
    var inquiries = localStorage.getItem('efast_real_inquiries');
    if (inquiries) { try { data.inquiries = JSON.parse(inquiries); } catch(e) {} }
    fetch('/api/settings', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (typeof Auth !== 'undefined' && Auth.getToken ? Auth.getToken() : '') },
        body: JSON.stringify(data)
    }).catch(function(e) { console.error('Sync to server failed:', e); });
}

function isV(id){ var e=document.getElementById(id); return e?e.value.trim():''; }
function sB64(file,cb){ var r=new FileReader();r.onload=function(e){cb(e.target.result);};r.readAsDataURL(file); }
function sImg(key,ik,b64){ var im=iload(key)||{};im[ik]=b64;isave(key,im); }
function gImg(key,ik){ var im=iload(key)||{};return im[ik]||''; }
function sT(msg,type){ var e=document.createElement('div');e.style.cssText='position:fixed;top:20px;right:20px;z-index:9999;padding:8px 16px;border-radius:8px;color:#fff;font-size:13px;animation:slideIn 0.3s ease;';e.style.background=type==='error'?'#ef4444':(type==='success'?'#22c55e':(type==='warning'?'#f59e0b':'#3b82f6'));e.textContent=msg;document.body.appendChild(e);setTimeout(function(){e.style.opacity='0';setTimeout(function(){e.remove();},300);},2500); }

// ===== Sidebar Section Toggle =====
function toggleSideSection(el) {
    var content = el.nextElementSibling;
    var arrow = el.querySelector('.s-arrow');
    var visible = content.style.display === 'block';
    content.style.display = visible ? 'none' : 'block';
    if (arrow) arrow.textContent = visible ? '▼' : '▲';
}

// ===== Settings Section Toggle =====
function toggleSettingsSection(el) {
    var content = el.closest('.settings-section').querySelector('.settings-content');
    var arrow = el.querySelector('.s-arrow');
    if (!content) return;
    var visible = content.style.display !== 'none';
    content.style.display = visible ? 'none' : 'block';
    if (arrow) arrow.textContent = visible ? '▼' : '▲';
}

// ===== Tab switching =====
function switchIsCustTab(idx, el) { sTab(el); document.getElementById('is-cust-tab0').style.display=idx===0?'block':'none'; document.getElementById('is-cust-tab1').style.display=idx===1?'block':'none'; }
function switchIsProdTab(idx, el) { sTab(el); document.getElementById('is-prod-tab0').style.display=idx===0?'block':'none'; document.getElementById('is-prod-tab1').style.display=idx===1?'block':'none'; }
function switchIsTermsTab(idx, el) { sTab(el); for(var i=0;i<4;i++) document.getElementById('is-terms-'+i).style.display='none'; document.getElementById('is-terms-'+idx).style.display='block'; }
function sTab(el) { el.parentElement.querySelectorAll('.s-tab').forEach(function(t){t.classList.remove('active');}); el.classList.add('active'); }

// ===== Init =====
function initInvoiceCenter() {
    if (typeof calculatePI === 'function') calculatePI();
    refreshAllIsLists();
    refreshIsRate();
    updateTopBarRate();
    initSystemSettings();
    if (!window._serverProducts) {
        loadCrmProductsForInvoice().then(function() { renderInvoiceForm(); });
    } else {
        renderInvoiceForm();
    }
}


// ===== 标签页切换 =====
function switchInvoiceTab(tab) {
    window._activeInvoiceTab = tab;
    document.querySelectorAll(".inv-tab-btn").forEach(function(b) {
        b.classList.toggle("active", b.getAttribute("data-tab") === tab);
    });
    document.querySelectorAll(".inv-tab-content").forEach(function(c) {
        c.style.display = c.getAttribute("data-tab") === tab ? "block" : "none";
    });
    // Hide PI-specific buttons (合计/导入CRM/生成订单/一键生成Excel) on non-PI tabs
    var isPI = (tab === 'pc-invoice');
    var preview = document.getElementById('is-form-preview');
    if (preview) {
        var card = preview.closest('.dashboard-card');
        if (card) card.style.display = isPI ? '' : 'none';
        var next = card ? card.nextElementSibling : null;
        if (next) next.style.display = isPI ? '' : 'none';
        if (next && next.nextElementSibling) next.nextElementSibling.style.display = isPI ? '' : 'none';
    }
    // Auto-add default product row for SQ/CQ if empty + init incoterm dropdowns
    if (tab === 'standard-quote') {
        initIncotermDropdowns();
        var sqHeaderSel = document.getElementById('sq-form-header');
        if (sqHeaderSel) {
            var headers = ih();
            var curVal = sqHeaderSel.value;
            sqHeaderSel.innerHTML = '<option value="">-- 手动输入 --</option>';
            headers.forEach(function(h) {
                sqHeaderSel.innerHTML += '<option value="' + h.name + '">' + h.name + '</option>';
            });
            if (headers.length > 0 && (!curVal || curVal === '')) {
                sqHeaderSel.value = headers[0].name;
                onSqHeaderSelect();
            } else { sqHeaderSel.value = curVal; }
        }
        var sqContainer = document.getElementById('sq-items-container');
        if (sqContainer && sqContainer.children.length === 0) addSqItem();
    }
    if (tab === 'custom-quote') {
        initIncotermDropdowns();
        var cqHeaderSel = document.getElementById('cq-form-header');
        if (cqHeaderSel) {
            var headers = ih();
            var curVal = cqHeaderSel.value;
            cqHeaderSel.innerHTML = '<option value="">-- 手动输入 --</option>';
            headers.forEach(function(h) {
                cqHeaderSel.innerHTML += '<option value="' + h.name + '">' + h.name + '</option>';
            });
            if (headers.length > 0 && (!curVal || curVal === '')) {
                cqHeaderSel.value = headers[0].name;
                onCqHeaderSelect();
            } else { cqHeaderSel.value = curVal; }
        }
        var cqContainer = document.getElementById('cq-items-container');
        if (cqContainer && cqContainer.children.length === 0) addCqItem();
    }
    if (tab === 'packing-list') { initPLHeaders(); initPLCustomers(); initPLMethods(); }
    if (tab === 'custom-order') { if (typeof window.initCustomOrderTab === 'function') window.initCustomOrderTab(); }
    if (tab === 'shenhan-invoice') { if (typeof window.initShenhanTab === 'function') window.initShenhanTab(); }
}

// ===== 从CRM服务器加载客户和产品到发票下拉 =====

function loadCrmCustomersForInvoice() {
    return fetch('/api/customers', { headers: { 'Authorization': 'Bearer ' + (Auth.getToken ? Auth.getToken() : '') } })
        .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function(res) {
            var customers = Array.isArray(res) ? res : (res.customers || res.data || []);
            window._crmCustomers = customers;
            console.log('[CRM] Loaded', customers.length, 'customers from server');
            return customers;
        })
        .catch(function(e) {
            console.warn('[CRM] Failed to load customers:', e.message);
            return [];
        });
}

// Helper: 从 window._crmCustomers 构建客户下拉数据
function getCrmCustomersForDropdown() {
    var custs = window._crmCustomers || [];
    var seen = {};
    var result = [];
    custs.forEach(function(c) {
        var name = c.contact || '';
        if (!name || seen[name]) return;
        seen[name] = true;
        result.push({
            name: name,
            attn: c.contact || '',
            tel: c.phone || '',
            address: c.address || '',
            po_no: '',
            terms_of_payment: '',
            shipping_term: '',
            currency: '',
            custom_field_1_label: '',
            custom_field_1_value: '',
            custom_field_2_label: '',
            custom_field_2_value: ''
        });
    });
    return result;
}
function loadCrmProductsForInvoice() {
    return fetch('/api/products', { headers: { 'Authorization': 'Bearer ' + (Auth.getToken ? Auth.getToken() : '') } })
        .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function(res) {
            var products = Array.isArray(res) ? res : (res.products || res.data || []);
            console.log('[CRM] Loaded', products.length, 'products from server');
            window._serverProducts = products;
            var existing = [];
            var models = [];
            var added = 0;
            products.forEach(function(p) {
                var prodModel = p.model || p.model_no || '';
                if (!prodModel || models.indexOf(prodModel) !== -1) return;
                var price = 0;
                if (typeof p.unit_price === 'number') price = p.unit_price;
                else if (p.priceTiers && p.priceTiers.length) price = p.priceTiers[0].price || 0;
                else if (p.purchaseCost) price = parseFloat(p.purchaseCost) || 0;
                existing.push({
                    model_no: prodModel,
                    product_name: p.productName || p.product_name || '',
                    description: p.description || '',
                    unit_price: price,
                    price_tiers: (function() {
                        var tiers = p.priceTiers || p.price_tiers || [];
                        return tiers.map(function(t, i) {
                            var nxt = (i + 1 < tiers.length) ? (tiers[i + 1].qty || tiers[i + 1].minQty || tiers[i + 1].min_qty || 1) : 999999;
                            return {
                                min_qty: t.qty || t.minQty || t.min_qty || 1,
                                max_qty: nxt - 1,
                                price: t.price || 0
                            };
                        });
                    })(),
                    image_path: p.imageName || p.image_path || '',
                    weight: p.weight || '',
                    dimensions: p.dimensions || '',
                    packingQty: p.packingQty || '',
                    cartonWeight: p.cartonWeight || '',
                    cartonSize: p.cartonSize || ''
                });
                models.push(prodModel);
                added++;
            });
            if (added > 0) {
                isave(IK.products, existing);
                console.log('[CRM] Added', added, 'products to local store');
            }
            return existing;
        })
        .catch(function(e) {
            console.warn('[CRM] Failed to load products:', e.message);
            return ipr();
        });
}
function openInvoiceBuilder() {
    document.querySelectorAll('.view-section').forEach(function(v){ v.classList.remove('active'); });
    document.querySelectorAll('.nav-menu .nav-item').forEach(function(n){ n.classList.remove('active'); });
    document.getElementById('nav-invoice-builder').classList.add('active');
    var view = document.getElementById('view-invoice-builder');
    if (view) view.classList.add('active');
    sessionStorage.setItem('efast_active_view', 'view-invoice-builder');
    console.log('[Invoice] Loading CRM data...');
    var needProducts = !window._serverProducts;
    var needCustomers = !window._crmCustomers;
    if (!needProducts && !needCustomers) {
        console.log('[Invoice] CRM data already cached, rendering immediately');
        renderInvoiceForm();
    } else {
        var promises = [];
        if (needCustomers) promises.push(loadCrmCustomersForInvoice());
        if (needProducts) promises.push(loadCrmProductsForInvoice());
        Promise.all(promises).then(function() {
            console.log('[Invoice] CRM data loaded, rendering form');
            renderInvoiceForm();
        }).catch(function(e) {
            console.warn('[Invoice] CRM load failed, rendering anyway:', e.message);
            renderInvoiceForm();
        });
    }
}

// ===== Sidebar List Rendering =====
function renderIsList(containerId, items, displayKey, onDelete) {
    var c = document.getElementById(containerId); if (!c) return;
    c.innerHTML = '';
    items.forEach(function (item, idx) {
        var d = document.createElement('div');
        d.className = 's-data-item';
        d.innerHTML = '<span>' + escapeHtml(typeof item === 'string' ? item : (item[displayKey] || '')) + '</span>' +
            (ib() ? '<span class="s-del" onclick="arguments[0].stopPropagation();(' + onDelete.toString() + ')(' + idx + ')">✕</span>' : '');
        c.appendChild(d);
    });
}
function refreshAllIsLists() {
    renderIsList('is-hdr-list', ih(), 'name', function(i){var h=ih();h.splice(i,1);isave(IK.headers,h);refreshAllIsLists();refreshIsDropdowns();sT('已删除','success');});
    renderIsList('is-cust-list', icu(), 'name', function(i){var c=icu();c.splice(i,1);isave(IK.customers,c);refreshAllIsLists();refreshIsDropdowns();sT('已删除','success');});
    renderIsList('is-prod-list', ipr(), 'model_no', function(i){var p=ipr();p.splice(i,1);isave(IK.products,p);refreshAllIsLists();refreshIsDropdowns();sT('已删除','success');});
    renderIsList('is-pay-list', ipa(), 'name', function(i){var p=ipa();p.splice(i,1);isave(IK.payments,p);refreshAllIsLists();refreshIsDropdowns();sT('已删除','success');});
    renderIsList('is-terms-payment-list', itp(), null, function(i){var t=itp();t.splice(i,1);isave(IK.termsPayment,t);refreshAllIsLists();refreshIsDropdowns();});
    renderIsList('is-terms-shipping-list', its(), null, function(i){var t=its();t.splice(i,1);isave(IK.termsShipping,t);refreshAllIsLists();refreshIsDropdowns();});
    renderIsList('is-terms-method-list', itm(), null, function(i){var t=itm();t.splice(i,1);isave(IK.termsMethods,t);refreshAllIsLists();refreshIsDropdowns();});
    renderIsList('is-terms-currency-list', itc(), null, function(i){var t=itc();t.splice(i,1);isave(IK.termsCurrencies,t);refreshAllIsLists();refreshIsDropdowns();});
}
function refreshIsRate() {
    var el = document.getElementById('is-rate-body'); if (!el) return;
    var r = ier().exchange_rate || 7.1;
    if (ib()) el.innerHTML = '<div class="s-field"><input type="number" step="0.0001" id="is-rate-input" value="' + r + '"></div><button class="btn-sync btn-sm" onclick="saveIsRate()">💾 更新汇率</button>';
    else el.innerHTML = '<div class="s-field"><input type="number" value="' + r + '" disabled></div><span style="font-size:10px;color:var(--text-muted);">仅管理员可设定</span>';
}


// ===== Save Operations =====
function saveIsHeader() {
    var name=isV('is-hdr-name'), company=isV('is-hdr-company'); if(!name||!company){sT('简称和公司全称必填','error');return;}
    var entry={name:name,company_name:company,contact:isV('is-hdr-contact'),manufacturer_info:isV('is-hdr-manufacturer'),shipper:isV('is-hdr-shipper'),ship_phone:isV('is-hdr-ship-phone'),ship_address:isV('is-hdr-ship-address')}, h=ih(), idx=h.findIndex(function(x){return x.name===name;});
    if(idx!==-1)h[idx]=entry;else h.push(entry);isave(IK.headers,h);syncSettingsToServer();refreshAllIsLists();refreshIsDropdowns();sT('保存成功','success');
}
function saveIsCustomer() {
    var name=isV('is-cust-name'); if(!name){sT('客户公司名必填','error');return;}
    var c=icu(); if(c.some(function(x){return x.name===name;})){sT('已存在','error');return;}
    c.push({name:name,attn:isV('is-cust-attn'),tel:isV('is-cust-tel'),address:isV('is-cust-addr'),po_no:'',terms_of_payment:'',shipping_term:'',currency:'',custom_field_1_label:isV('is-cust-lbl1')||'VAT No.',custom_field_1_value:isV('is-cust-val1'),custom_field_2_label:isV('is-cust-lbl2')||'email',custom_field_2_value:isV('is-cust-val2')});
    isave(IK.customers,c);refreshAllIsLists();refreshIsDropdowns();sT('保存成功','success');
}
function saveIsProduct() {
    var model=isV('is-prod-model'); if(!model){sT('型号必填','error');return;}
    var p=ipr(); if(p.some(function(x){return x.model_no===model;})){sT('型号已存在','error');return;}
    var price=parseFloat(isV('is-prod-price'))||0, tiers=sParseTiers(isV('is-prod-tiers'));
    var imgEl=document.getElementById('is-prod-img');
    var doSave=function(imgKey){ p.push({model_no:model,image_path:imgKey||'',unit_price:price,price_tiers:tiers}); isave(IK.products,p); refreshAllIsLists();refreshIsDropdowns();sT('保存成功','success'); };
    if(imgEl&&imgEl.files[0]){sB64(imgEl.files[0],function(b64){var k='prod_'+model.replace(/[^a-zA-Z0-9]/g,'');sImg(IK.productImages,k,b64);doSave(k);});}else{doSave('');}
}
function saveIsPayment() {
    var name=isV('is-pay-name'); if(!name){sT('账户简称必填','error');return;}
    var ps=ipa(), text=isV('is-pay-text'), imgEl=document.getElementById('is-pay-img');
    var doSave=function(imgKey){ var idx=ps.findIndex(function(x){return x.name===name;}),entry={name:name,text:text,image_path:imgKey||''};
        if(idx!==-1){if(!imgKey)entry.image_path=ps[idx].image_path||'';ps[idx]=entry;}else{ps.push(entry);}
        isave(IK.payments,ps);syncSettingsToServer();refreshAllIsLists();refreshIsDropdowns();sT('保存成功','success'); };
    if(imgEl&&imgEl.files[0]){sB64(imgEl.files[0],function(b64){var k='pay_'+name.replace(/[^a-zA-Z0-9]/g,'');sImg(IK.paymentImages,k,b64);doSave(k);});}else{doSave('');}
}
function addIsTerm(type) {
    var m={payment:['is-terms-payment',IK.termsPayment,itp],shipping:['is-terms-shipping',IK.termsShipping,its],method:['is-terms-method',IK.termsMethods,itm],currency:['is-terms-currency',IK.termsCurrencies,itc]}[type];if(!m)return;
    var val=isV(m[0]);if(!val)return;var list=m[2]();if(list.indexOf(val)!==-1)return;list.push(val);isave(m[1],list);syncSettingsToServer();document.getElementById(m[0]).value='';refreshAllIsLists();refreshIsDropdowns();sT('添加成功','success');
}

// ===== Tier Parser =====
function sParseTiers(str){if(!str)return[];var tiers=[];str.replace(/；/g,';').replace(/：/g,':').split(';').forEach(function(p){p=p.trim();if(!p||p.indexOf(':')===-1)return;var s=p.split(':',2),price=parseFloat(s[1].trim());if(isNaN(price))return;var q=s[0].trim();if(q.indexOf('-')!==-1){var mm=q.split('-',2);tiers.push({min_qty:parseInt(mm[0]),max_qty:parseInt(mm[1]),price:price});}else if(q.indexOf('+')!==-1){tiers.push({min_qty:parseInt(q.replace('+','')),max_qty:999999999,price:price});}else{var n=parseInt(q);tiers.push({min_qty:n,max_qty:n,price:price});}});return tiers.sort(function(a,b){return a.min_qty-b.min_qty;});}
function sFmtTiers(t){if(!t||!t.length)return'';return t.map(function(x){if(x.max_qty>=999999999)return x.min_qty+'+:'+x.price;return x.min_qty+'-'+x.max_qty+':'+x.price;}).join('; ');}
function sMatchPrice(product,qty){var t=product.price_tiers||[];if(!t.length)return product.unit_price||0;for(var i=0;i<t.length;i++){if(qty>=t[i].min_qty&&qty<=t[i].max_qty)return t[i].price;}return product.unit_price||0;}

// ===== Dropdown Refresh =====
function refreshIsDropdowns(){
    console.log('[DROPDOWNS] START. customers:',icu().length,'products:',ipr().length,'headers:',ih().length);
    var hSel=document.getElementById('is-form-header');if(hSel){var hv=hSel.value;hSel.innerHTML='<option value="">-- 手动输入 --</option>';ih().forEach(function(h){hSel.innerHTML+='<option value="'+escapeHtml(h.name)+'">'+escapeHtml(h.name)+'</option>';});hSel.value=hv;}
    var cSel=document.getElementById('is-form-customer');
    console.log('[DROPDOWNS] cSel found:',!!cSel);
    if(cSel){var cv=cSel.value;cSel.innerHTML="<option value=\"\">-- 手动输入 --</option>";
        var t3=(window.Auth&&Auth.getToken)?Auth.getToken():"";
        fetch("/api/customers",{headers:{"Authorization":"Bearer "+t3}}).then(function(r){return r.json();}).then(function(res){
            var allCusts=Array.isArray(res)?res:(res.customers||[]);
            var opts=""; var seen3={};
            allCusts.forEach(function(c){var n=c.contact||"";if(n&&!seen3[n]){seen3[n]=true;opts+="<option value=\""+escapeHtml(n)+"\">"+escapeHtml(n)+"</option>";}});
            cSel.innerHTML="<option value=\"\">-- 手动输入 --</option>"+opts; cSel.value=cv;
        }).catch(function(e){});}
    var pSel=document.getElementById('is-form-payment');if(pSel){var pv=pSel.value;pSel.innerHTML='<option value="">-- 手动输入 --</option>';ipa().forEach(function(p){pSel.innerHTML+='<option value="'+escapeHtml(p.name)+'">'+escapeHtml(p.name)+'</option>';});pSel.value=pv;}
    var ptSel=document.getElementById('is-form-payterm');if(ptSel){var ptv=ptSel.value;ptSel.innerHTML='<option value="">-- 请选择 --</option>';itp().forEach(function(t){ptSel.innerHTML+='<option value="'+escapeHtml(t)+'">'+escapeHtml(t)+'</option>';});ptSel.innerHTML+='<option value="__custom__">-- 手动输入 --</option>';ptSel.value=ptv;}
    var stSel=document.getElementById('is-form-shipterm');if(stSel){var stv=stSel.value;stSel.innerHTML='<option value="">-- 请选择 --</option>';its().forEach(function(t){stSel.innerHTML+='<option value="'+escapeHtml(t)+'">'+escapeHtml(t)+'</option>';});stSel.innerHTML+='<option value="__custom__">-- 手动输入 --</option>';stSel.value=stv;}
    var smSel=document.getElementById('is-form-shipmethod');if(smSel){var smv=smSel.value;smSel.innerHTML='<option value="">-- 无 --</option>';itm().forEach(function(m){smSel.innerHTML+='<option value="'+escapeHtml(m)+'">'+escapeHtml(m)+'</option>';});smSel.innerHTML+='<option value="__custom__">-- 手动输入 --</option>';smSel.value=smv||'Express';}
    var currSel=document.getElementById('is-form-currency');if(currSel){var currv=currSel.value;currSel.innerHTML='';itc().forEach(function(c){currSel.innerHTML+='<option value="'+escapeHtml(c)+'">'+escapeHtml(c)+'</option>';});currSel.innerHTML+='<option value="Other">Other...</option>';currSel.value=currv||'USD';}
    var custDL=document.getElementById('is-customer-suggestions');var custDL=document.getElementById("is-customer-suggestions");if(custDL){
        var t4=(window.Auth&&Auth.getToken)?Auth.getToken():"";
        fetch("/api/customers",{headers:{"Authorization":"Bearer "+t4}}).then(function(r){return r.json();}).then(function(res){
            var allCusts=Array.isArray(res)?res:(res.customers||[]);
            var opts=""; var seen4={};
            allCusts.forEach(function(c){var n=c.contact||"";if(n&&!seen4[n]){seen4[n]=true;opts+="<option value=\""+escapeHtml(n)+"\">";}});
            custDL.innerHTML=opts;
        }).catch(function(e){});
    }
    console.log('[DROPDOWNS] DONE');
}
// ===== Import/Export =====
function downloadIsCustTemplate(){sDownload('\uFEFF'+['客户公司名 *,联系人 / Attn,电话 / Tel,收货地址 / Address,自定义项1标签,自定义项1内容,自定义项2标签,自定义项2内容'].join(',')+'\nExample Company Ltd,John Smith,+86 13560723375,123 Business Road Shenzhen,VAT No.,GB123456789,email,john@example.com','客户导入模板.csv','text/csv;charset=utf-8');}
function downloadIsProdTemplate(){sDownload('\uFEFF型号 / Model No. *,标准单价 / Unit Price *,阶梯价格\nZF71,1.20,1-199:1.20; 200-2999:1.10; 3000+:1.00','产品导入模板.csv','text/csv;charset=utf-8');}
function importIsCustomers(input){sImportFile(input,'cust',ICU());}
function importIsProducts(input){sImportFile(input,'prod',IPR());}
function exportIsCustomersCSV(){var c=ICU();if(!c.length){sT('客户池为空','warning');return;}var h='客户公司名,联系人,电话,收货地址,自定义项1标签,自定义项1内容,自定义项2标签,自定义项2内容';var rows=c.map(function(x){return [x.name,x.attn,x.tel,x.address,x.custom_field_1_label,x.custom_field_1_value,x.custom_field_2_label,x.custom_field_2_value].map(function(v){return'"'+(v||'').replace(/"/g,'""')+'"';}).join(',');}).join('\n');sDownload('\uFEFF'+h+'\n'+rows,'客户信息导出_'+new Date().toISOString().slice(0,10)+'.csv','text/csv;charset=utf-8');}
function exportIsProductsCSV(){var p=IPR();if(!p.length){sT('产品库为空','warning');return;}var h='型号,标准单价,阶梯价格';var rows=p.map(function(x){return '"'+x.model_no+'",'+x.unit_price.toFixed(2)+',"'+sFmtTiers(x.price_tiers||[])+'"';}).join('\n');sDownload('\uFEFF'+h+'\n'+rows,'产品数据导出_'+new Date().toISOString().slice(0,10)+'.csv','text/csv;charset=utf-8');}

function ICU(){return icu();} function IPR(){return ipr();}

function sImportFile(input,type,existingArr){
    var file=input.files[0];if(!file)return;var r=new FileReader();r.onload=function(e){var strategy=isV('is-'+type+'-conflict'),existing={};existingArr.forEach(function(x,i){existing[type==='cust'?x.name:x.model_no]=i;});
    var added=0,skipped=0,overwritten=0;try{var newItems=[];
    if(file.name.endsWith('.json')){var data=JSON.parse(e.target.result);if(Array.isArray(data))data.forEach(function(item){if(type==='cust'&&item.name)newItems.push(normCust(item));else if(type==='prod'&&item.model_no)newItems.push(normProd(item));});}
    else{var lines=e.target.result.split('\n').filter(function(l){return l.trim();});for(var i=1;i<lines.length;i++){var c=sParseCSV(lines[i]);if(!c[0]||!c[0].trim())continue;if(type==='cust')newItems.push(normCustArr(c));else newItems.push(normProdArr(c));}}
    newItems.forEach(function(ni){var key=type==='cust'?ni.name:ni.model_no;if(key in existing){if(strategy==='overwrite'){if(type==='prod'&&existingArr[existing[key]].image_path&&!ni.image_path)ni.image_path=existingArr[existing[key]].image_path;existingArr[existing[key]]=ni;overwritten++;}else if(strategy==='skip'){skipped++;}else{ni[type==='cust'?'name':'model_no']=key+'_'+Date.now();existingArr.push(ni);added++;}}else{existingArr.push(ni);existing[key]=existingArr.length-1;added++;}});
    isave(type==='cust'?IK.customers:IK.products,existingArr);refreshAllIsLists();refreshIsDropdowns();sT('导入完成！新增:'+added+' 覆盖:'+overwritten+' 跳过:'+skipped,'success');}catch(err){sT('导入失败:'+err.message,'error');}};r.readAsText(file,'utf-8');input.value='';
}
function normCust(item){return{name:item.name.trim(),attn:(item.attn||'').trim(),tel:(item.tel||'').trim(),address:(item.address||'').trim(),po_no:'',terms_of_payment:'',shipping_term:'',currency:'',custom_field_1_label:(item.custom_field_1_label||'VAT No.').trim(),custom_field_1_value:(item.custom_field_1_value||'').trim(),custom_field_2_label:(item.custom_field_2_label||'email').trim(),custom_field_2_value:(item.custom_field_2_value||'').trim()};}
function normCustArr(c){return{name:c[0].trim(),attn:(c[1]||'').trim(),tel:(c[2]||'').trim(),address:(c[3]||'').trim(),po_no:'',terms_of_payment:'',shipping_term:'',currency:'',custom_field_1_label:(c[4]||'VAT No.').trim(),custom_field_1_value:(c[5]||'').trim(),custom_field_2_label:(c[6]||'email').trim(),custom_field_2_value:(c[7]||'').trim()};}
function normProd(item){return{model_no:item.model_no.trim(),unit_price:parseFloat(item.unit_price)||0,image_path:(item.image_path||'').trim(),price_tiers:item.price_tiers||[]};}
function normProdArr(c){var price=parseFloat(c[1])||0,tiers=sParseTiers((c[2]||'').trim());return{model_no:c[0].trim(),unit_price:price,image_path:'',price_tiers:tiers};}

function sParseCSV(line){var r=[],cur='',inQ=false;for(var i=0;i<line.length;i++){var ch=line[i];if(ch==='"')inQ=!inQ;else if(ch===','&&!inQ){r.push(cur);cur='';}else cur+=ch;}r.push(cur);return r;}
function sDownload(content,fn,mime){var b=new Blob([content],{type:mime}),url=URL.createObjectURL(b),a=document.createElement('a');a.href=url;a.download=fn;document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);}

// ============ Right Side: Invoice Form ============
window._isItems = {}; window._isCounter = 0;

function renderInvoiceForm() {
    var c = document.getElementById('invoice-builder-content');
    if (!c) return;
    try {
    window._activeInvoiceTab = window._activeInvoiceTab || 'pc-invoice';

// Inject tab styles
(function() {
    if (!document.getElementById('inv-tab-styles')) {
        var style = document.createElement('style');
        style.id = 'inv-tab-styles';
        style.textContent = '.inv-tab-btn.active { color: #1f3864 !important; border-bottom-color: #1f3864 !important; }';
        document.head.appendChild(style);
    }
})();
    refreshAllIsLists();
    var today = new Date(), ds = today.getFullYear().toString().slice(-2) + String(today.getMonth()+1).padStart(2,'0') + String(today.getDate()).padStart(2,'0');
    var hdrs = ih(), defMfr = hdrs.length > 0 ? (hdrs[0].manufacturer_info||'') : '';

    c.innerHTML = 
    '<div class="inv-tab-bar" style="display:flex;gap:0;margin-bottom:16px;border-bottom:2px solid #e5e7eb;">' +
    '<button class="inv-tab-btn active" data-tab="pc-invoice" onclick="switchInvoiceTab(\'pc-invoice\')" style="padding:10px 20px;border:none;background:none;font-size:1.05rem;font-weight:700;color:#6b7280;cursor:pointer;border-bottom:3px solid transparent;transition:all 0.2s;">P/C Invoice</button>' +
    '<button class="inv-tab-btn" data-tab="standard-quote" onclick="switchInvoiceTab(\'standard-quote\')" style="padding:10px 20px;border:none;background:none;font-size:1.05rem;font-weight:700;color:#6b7280;cursor:pointer;border-bottom:3px solid transparent;transition:all 0.2s;">Standard Quote</button>' +
    '<button class="inv-tab-btn" data-tab="custom-quote" onclick="switchInvoiceTab(\'custom-quote\')" style="padding:10px 20px;border:none;background:none;font-size:1.05rem;font-weight:700;color:#6b7280;cursor:pointer;border-bottom:3px solid transparent;transition:all 0.2s;">Customize Quote</button>' +
    '<button class="inv-tab-btn" data-tab="packing-list" onclick="switchInvoiceTab(\'packing-list\')" style="padding:10px 20px;border:none;background:none;font-size:1.05rem;font-weight:700;color:#6b7280;cursor:pointer;border-bottom:3px solid transparent;transition:all 0.2s;">Packing List</button>' +
    '<button class="inv-tab-btn" data-tab="custom-order" onclick="switchInvoiceTab(\'custom-order\')" style="padding:10px 20px;border:none;background:none;font-size:1.05rem;font-weight:700;color:#6b7280;cursor:pointer;border-bottom:3px solid transparent;transition:all 0.2s;">定制单</button>' +
    '<button class="inv-tab-btn" data-tab="shenhan-invoice" onclick="switchInvoiceTab(\'shenhan-invoice\')" style="padding:10px 20px;border:none;background:none;font-size:1.05rem;font-weight:700;color:#6b7280;cursor:pointer;border-bottom:3px solid transparent;transition:all 0.2s;">深汉发票</button>' +
    '</div>' +
    '<div class="inv-tab-content" data-tab="pc-invoice" style="display:flex;flex-direction:column;gap:16px;">' +
    '<div class="dashboard-card"><div class="card-header"><h2>📋 单据特征</h2></div>' +
    '<div class="form-container"><div class="form-row" style="display:flex;flex-wrap:nowrap;gap:8px;"><div class="form-group" style="flex:1;min-width:0;"><label style="font-size:0.78rem;white-space:nowrap;">单据类型 *</label><select id="is-form-doctype" required style="width:100%;"><option value="PROFORMA INVOICE">PROFORMA INVOICE</option><option value="COMMERCIAL INVOICE">COMMERCIAL INVOICE</option></select></div>' +
    '<div class="form-group" style="flex:1;min-width:0;"><label style="font-size:0.78rem;white-space:nowrap;">单号</label><input id="is-form-invoiceno" style="width:100%;" value="SC'+ds+'01"></div>' +
    '<div class="form-group" style="flex:1;min-width:0;"><label style="font-size:0.78rem;white-space:nowrap;">日期</label><input type="date" id="is-form-date" style="width:100%;" value="'+today.toISOString().split('T')[0]+'"></div></div></div></div>' +

    '<div class="dashboard-grid">' +
    '<div class="dashboard-card"><div class="card-header"><h2>🏢 公司抬头</h2></div><div class="form-container">' +
    '<div class="form-group"><label>从抬头库载入</label><select id="is-form-header" onchange="onIsHeaderSelect()"><option value="">-- 手动输入 --</option></select></div>' +
    '<div class="form-group"><label>公司英文全称</label><input id="is-form-company"></div>' +
    '<div class="form-group"><label>公司联系信息</label><textarea id="is-form-contact" rows="3"></textarea></div>' +
    '<div class="form-group"><label>制造商信息</label><textarea id="is-form-manufacturer" rows="3">'+escapeHtml(defMfr)+'</textarea></div></div></div>' +

    '<div class="dashboard-card"><div class="card-header"><h2>👤 客户信息</h2></div><div class="form-container">' +
    '<div class="form-group"><label>从客户库载入</label><select id="is-form-customer" onchange="onIsCustomerSelect()"><option value="">-- 手动输入 --</option></select></div>' +
    '<div class="form-group"><label>客户名称 (To)</label><input id="is-form-custname" list="is-customer-suggestions" oninput="onIsCustnameInput()" onchange="onIsCustnameInput()" autocomplete="off"><datalist id="is-customer-suggestions"></datalist></div>' +
    '<div class="form-row"><div class="form-group"><label>联系人</label><input id="is-form-custattn"></div><div class="form-group"><label>电话</label><input id="is-form-custtel"></div></div>' +
    '<div class="form-group"><label>地址</label><textarea id="is-form-custaddr" rows="2"></textarea></div>' +
    '<div class="form-group"><label>PO单号</label><input id="is-form-custpono"></div>' +
    '<div class="form-row"><div class="form-group"><label>自定义项1</label><input id="is-form-cf1lbl" placeholder="标签" value=""></div><div class="form-group"><label>自定义项2</label><input id="is-form-cf2lbl" placeholder="标签" value=""></div></div>' +
    '<div class="form-row"><div class="form-group"><input id="is-form-cf1val" placeholder="内容" style="width:100%;"></div><div class="form-group"><input id="is-form-cf2val" placeholder="内容" style="width:100%;"></div></div></div></div></div>' +

    '<div class="dashboard-card"><div class="card-header"><h2>📜 基本条款</h2></div>' +
    '<div class="form-container"><div class="form-row"><div class="form-group"><label>币种</label><select id="is-form-currency" onchange="onIsCurrencyChange()"></select><div id="is-form-custom-curr" style="display:none;"><input id="is-form-currency-c" placeholder="币种名"><input id="is-form-currency-s" placeholder="符号 €"></div></div>' +
    '<div class="form-group"><label>运输方式</label><select id="is-form-shipmethod" onchange="onIsShipMethodChange()"></select><input id="is-form-shipmethod-c" placeholder="自定义" style="display:none;"></div></div>' +
    '<div class="form-row"><div class="form-group"><label>付款条件 *</label><select id="is-form-payterm" onchange="onIsPayTermChange()"></select><input id="is-form-payterm-c" placeholder="自定义" style="display:none;"></div>' +
    '<div class="form-group"><label>贸易术语 *</label><select id="is-form-shipterm" onchange="onIsShipTermChange()"></select><div id="is-form-shipterm-p" style="display:none;"><label id="is-form-shipterm-pl">装运地</label><input id="is-form-shipterm-pv" placeholder="Shenzhen"></div><input id="is-form-shipterm-c" placeholder="自定义" style="display:none;"></div></div></div></div>' +

    '<div class="dashboard-card"><div class="card-header"><h2>📦 商品明细</h2></div>' +
    '<div id="is-items-container"></div><button class="btn-action" onclick="addIsItem()" style="width:100%;margin-top:12px;padding:10px;border:1px dashed #cbd5e1;border-radius:8px;background:#f8fafc;color:#64748b;font-size:0.9rem;cursor:pointer;">➕ 新增产品行</button></div>' +

    '<div class="dashboard-card"><div class="card-header"><h2>🚚 运费和备注</h2></div>' +
    '<div class="form-container"><div class="form-row"><div class="form-group"><label>运费</label><input type="number" step="0.5" id="is-form-shippingcost" value="2.00"></div><div class="form-group"><label>备注</label><textarea id="is-form-remarks" rows="2">Packaging details: Standard color box for inner packing, Strong neutral carton for external packing</textarea></div></div></div></div>' +

    '<div class="dashboard-card"><div class="card-header"><h2>💳 收款信息</h2></div><div class="form-container">' +
    '<div class="form-group"><label>收款账户模板</label><select id="is-form-payment" onchange="onIsPaymentSelect()"><option value="">-- 手动输入 --</option></select></div>' +
    '<div class="form-group"><label>银行付款详情</label><textarea id="is-form-paytext" rows="5"></textarea></div>' +
    '<div class="form-group" style="display:flex;align-items:center;justify-content:center;min-width:150px;"><img id="is-form-payimg" src="" style="max-width:150px;max-height:150px;display:none;border:1px solid #e2e8f0;border-radius:6px;" alt="收款码"></div></div></div></div>' +

    '<div class="dashboard-card" style="background:var(--accent-blue);"><div style="display:flex;align-items:center;gap:12px;"><span>📊 合计:</span><span id="is-form-preview" style="font-size:1.3rem;font-weight:800;">$ 0.00</span></div></div>' +
    '<div style="display:flex;gap:12px;margin-bottom:12px;"><button class="btn-action" style="flex:1;padding:12px;font-size:0.95rem;background:#f59e0b;color:white;border:none;border-radius:8px;cursor:pointer;" onclick="isImportCRM()">📋 导入CRM</button><button class="btn-action" style="flex:1;padding:12px;font-size:0.95rem;background:#10b981;color:white;border:none;border-radius:8px;cursor:pointer;" onclick="isGenerateOrder()">📦 生成订单</button><button class="btn-action" style="flex:1;padding:12px;font-size:0.95rem;background:#6366f1;color:white;border:none;border-radius:8px;cursor:pointer;" onclick="isGeneratePL()">📋 生成装箱单</button></div>' +
    '<div style="display:flex;gap:12px;"><button class="btn-action" style="flex:1;padding:16px;font-size:1.1rem;" onclick="isGenerate()">📊 一键生成 Excel 发票</button><button class="btn-action" id="is-download-btn" style="flex:1;padding:16px;font-size:1.1rem;background:#0d9488;display:none;" onclick="isDownloadLast()">📜 下载最近生成的发票</button></div></div>' +

    // ===== STANDARD QUOTE TAB =====
    '<div class="inv-tab-content" data-tab="standard-quote" style="display:none;flex-direction:column;gap:16px;">' +
    '<div style="display:flex;gap:16px;">' +
    '<div class="dashboard-card" style="flex:1;"><div class="card-header"><h2>📝 报价标题</h2></div>' +
    '<div class="form-container"><div class="form-group"><input id="sq-form-title" placeholder="e.g. QUOTATION" style="width:100%;font-size:1rem;padding:8px 12px;"></div></div></div>' +
    '<div class="dashboard-card" style="flex:1;"><div class="card-header"><h2>🏢 公司抬头</h2></div>' +
    '<div class="form-container"><div class="form-group"><label>从抬头库载入</label><select id="sq-form-header" onchange="onSqHeaderSelect()"><option value="">-- 手动输入 --</option></select></div>' +
    '<div class="form-group"><label>公司联系信息</label><textarea id="sq-form-contact" rows="3"></textarea></div></div></div></div>' +
    '<div class="dashboard-card"><div class="card-header"><h2>📋 报价信息</h2></div>' +
    '<div class="form-container"><div class="form-row" style="display:flex;flex-wrap:nowrap;gap:8px;">' +
    '<div class="form-group" style="flex:1;"><label>Date</label><input type="date" id="sq-form-date" style="width:100%;" value="'+today.toISOString().split("T")[0]+'"></div>' +
    '<div class="form-group" style="flex:1;"><label>Validity</label><input id="sq-form-validity" style="width:100%;" value="60 days"></div>' +
    '<div class="form-group" style="flex:1;"><label>Incoterm</label><select id="sq-form-incoterm" style="width:100%;"></select></div>' +
    '</div></div></div>' +
    '<div class="dashboard-card"><div class="card-header"><h2>📦 产品明细</h2></div><div id="sq-items-container"></div><button class="btn-action" onclick="addSqItem()" style="width:100%;margin-top:12px;padding:10px;border:1px dashed #cbd5e1;border-radius:8px;background:#f8fafc;color:#64748b;font-size:0.9rem;cursor:pointer;">➕ 新增产品行</button></div>' +
    '<div style="display:flex;gap:12px;"><button class="btn-action" style="flex:1;padding:16px;font-size:1.1rem;" onclick="isGenerateSQ()">📊 一键生成 Standard Quote</button></div></div>' +

    // ===== CUSTOMIZE QUOTE TAB =====
    '<div class="inv-tab-content" data-tab="custom-quote" style="display:none;flex-direction:column;gap:16px;">' +
    '<div style="display:flex;gap:16px;">' +
    '<div class="dashboard-card" style="flex:1;"><div class="card-header"><h2>📝 报价标题</h2></div>' +
    '<div class="form-container"><div class="form-group"><input id="cq-form-title" placeholder="e.g. QUOTATION" style="width:100%;font-size:1rem;padding:8px 12px;"></div></div></div>' +
    '<div class="dashboard-card" style="flex:1;"><div class="card-header"><h2>🏢 公司抬头</h2></div>' +
    '<div class="form-container"><div class="form-group"><label>从抬头库载入</label><select id="cq-form-header" onchange="onCqHeaderSelect()"><option value="">-- 手动输入 --</option></select></div>' +
    '<div class="form-group"><label>公司联系信息</label><textarea id="cq-form-contact" rows="3"></textarea></div></div></div></div>' +
    '<div class="dashboard-card"><div class="card-header"><h2>📋 报价信息</h2></div>' +
    '<div class="form-container"><div class="form-row" style="display:flex;flex-wrap:nowrap;gap:8px;">' +
    '<div class="form-group" style="flex:1;"><label>Date</label><input type="date" id="cq-form-date" style="width:100%;" value="'+today.toISOString().split("T")[0]+'"></div>' +
    '<div class="form-group" style="flex:1;"><label>Validity</label><input id="cq-form-validity" style="width:100%;" value="60 days"></div>' +
    '<div class="form-group" style="flex:1;"><label>Incoterm</label><select id="cq-form-incoterm" style="width:100%;"></select></div>' +
    '</div></div></div>' +
    '<div class="dashboard-card"><div class="card-header"><h2>📦 产品明细</h2></div><div id="cq-items-container"></div><button class="btn-action" onclick="addCqItem()" style="width:100%;margin-top:12px;padding:10px;border:1px dashed #cbd5e1;border-radius:8px;background:#f8fafc;color:#64748b;font-size:0.9rem;cursor:pointer;">➕ 新增产品行</button></div>' +
    '<div style="display:flex;gap:12px;"><button class="btn-action" style="flex:1;padding:16px;font-size:1.1rem;" onclick="isGenerateCQ()">📊 一键生成 Customize Quote</button></div></div>' + 
    '<div class="inv-tab-content" data-tab="packing-list" style="display:none;flex-direction:column;gap:16px;">' +
    '<div class="dashboard-card"><div class="card-header"><h2>📋 单据特征</h2></div>' +
    '<div class="form-container"><div class="form-row" style="display:flex;flex-wrap:nowrap;gap:8px;">' +
    '<div class="form-group" style="flex:1;min-width:0;"><label style="font-size:0.78rem;white-space:nowrap;">Packing List No.</label><input id="pl-form-no" style="width:100%;" value="PL'+ds+'01"></div>' +
    '<div class="form-group" style="flex:1;min-width:0;"><label style="font-size:0.78rem;white-space:nowrap;">Date</label><input type="date" id="pl-form-date" style="width:100%;" value="'+today.toISOString().split('T')[0]+'"></div>' +
    '<div class="form-group" style="flex:1;min-width:0;"><label style="font-size:0.78rem;white-space:nowrap;">Shipping Method</label><select id="pl-form-method-sel" style="width:100%;" onchange="onPLMethodChange()"><option value="">-- 手动输入 --</option></select><input id="pl-form-method" style="width:100%;display:none;"></div>' +
    '<div class="form-group" style="flex:1;min-width:0;"><label style="font-size:0.78rem;white-space:nowrap;">Destination</label><input id="pl-form-dest" style="width:100%;" placeholder="自动解析"></div>' +
    '</div></div></div>' +
    '<div class="dashboard-grid">' +
    '<div class="dashboard-card"><div class="card-header"><h2>📦 Sender</h2></div><div class="form-container">' +
    '<div class="form-group"><label>从抬头库载入</label><select id="pl-form-header" onchange="onPLHeaderSelect()"><option value="">-- 手动输入 --</option></select></div>' +
    '<div class="form-group"><label>公司英文全称</label><input id="pl-form-company"></div>' +
    '<div class="form-group"><label>发货人</label><input id="pl-form-shipper"></div>' +
    '<div class="form-row"><div class="form-group"><label>发货电话</label><input id="pl-form-ship-phone"></div><div class="form-group"><label>发货地址</label><input id="pl-form-ship-address"></div></div>' +
    '<div class="form-group"><label>联系详情</label><textarea id="pl-form-contact" rows="3"></textarea></div>' +
    '</div></div>' +
    '<div class="dashboard-card"><div class="card-header"><h2>📥 Receiver</h2></div><div class="form-container">' +
    '<div class="form-group"><label>从客户库载入</label><input id="pl-form-customer" list="pl-customer-suggestions" onchange="onPLCustomerSelect()" placeholder="输入客户名联想…" autocomplete="off"><datalist id="pl-customer-suggestions"></datalist></div>' +
    '<div class="form-group"><label>收货人</label><input id="pl-form-consignee"></div>' +
    '<div class="form-row"><div class="form-group"><label>收货电话</label><input id="pl-form-phone"></div><div class="form-group"><label>收货地址</label><input id="pl-form-address"></div></div>' +
    '</div></div>' +
    '</div>' +
    '<div class="dashboard-card"><div class="card-header"><h2>📦 产品明细</h2></div>' +
    '<div class="form-container">' +
    '<datalist id="pl-model-suggestions"></datalist><div class="form-group"><label>Shipping Mark</label><input id="pl-form-mark" style="width:100%;" placeholder="所有产品共用同一个 Shipping Mark"></div>' +
    // CTN Groups
    '<div style="margin:8px 0;"><div style="display:flex;align-items:center;gap:8px;"><label style="font-size:0.78rem;font-weight:600;">CTN 编组</label><span style="font-size:0.7rem;color:#94a3b8;">(拖拽产品行到编组卡片)</span></div>' +
    '<div id="pl-groups-container" style="display:flex;gap:8px;flex-wrap:wrap;padding:8px;min-height:40px;border:1px dashed #cbd5e1;border-radius:8px;background:#f8fafc;margin-top:4px;"></div>' +
    '<div style="display:flex;gap:8px;margin-top:4px;"><input id="pl-group-input" placeholder="输入 CTN 编号" style="flex:1;padding:4px 8px;font-size:0.85rem;border:1px solid #cbd5e1;border-radius:4px;" onkeydown="if(event.key===\x27Enter\x27){addPLGroup();event.preventDefault();}"><button class="btn-action" style="padding:4px 12px;font-size:0.8rem;background:#6366f1;color:white;border:none;border-radius:4px;cursor:pointer;" onclick="addPLGroup()">+ 新增编组</button></div></div>' +
    // Product table with all inputs
    '<div style="overflow-x:auto;margin-top:8px;"><table style="width:100%;border-collapse:collapse;font-size:11px;" id="pl-items-table">' +
    '<thead><tr style="background:#f1f5f9;">' +
    '<th style="width:26px;padding:2px;border:1px solid #e2e8f0;"></th>' +
    '<th style="padding:4px 6px;border:1px solid #e2e8f0;">CTN</th>' +
    '<th style="padding:4px 6px;border:1px solid #e2e8f0;">Model No.</th>' +
    '<th style="padding:4px 6px;border:1px solid #e2e8f0;">Product Desc</th>' +
    '<th style="padding:4px 6px;border:1px solid #e2e8f0;">Qty/CTN</th>' +
    '<th style="padding:4px 6px;border:1px solid #e2e8f0;">Carton(cm)</th>' +
    '<th style="padding:4px 6px;border:1px solid #e2e8f0;">CTN Qty</th>' +
    '<th style="padding:4px 6px;border:1px solid #e2e8f0;">Total Qty</th>' +
    '<th style="padding:4px 6px;border:1px solid #e2e8f0;">N.W.(kg)</th>' +
    '<th style="padding:4px 6px;border:1px solid #e2e8f0;">G.W.(kg)</th>' +
    '<th style="padding:4px 6px;border:1px solid #e2e8f0;">Tot G.W.</th>' +
    '<th style="padding:4px 6px;border:1px solid #e2e8f0;">CBM</th>' +
    '<th style="width:24px;"></th>' +
    '</tr></thead><tbody id="pl-items-body"></tbody></table></div>' +
    '<button class="btn-action" style="margin-top:8px;padding:6px 16px;font-size:0.85rem;background:#e2e8f0;color:#334155;border:none;border-radius:6px;cursor:pointer;" onclick="addPLItem()">+ 新增产品行</button>' +
    '</div></div>' +
    '<div style="display:flex;gap:12px;margin-top:8px;"><button class="btn-action" style="flex:1;padding:16px;font-size:1.1rem;background:#6366f1;color:white;border:none;border-radius:8px;cursor:pointer;" onclick="isGeneratePLExcel()">📊 一键生成 Packing List Excel</button><button class="btn-action" id="pl-dl-btn" style="padding:16px 24px;font-size:1.1rem;background:#10b981;color:white;border:none;border-radius:8px;cursor:pointer;" onclick="isDownloadPL()" disabled>📜 下载</button></div>' +
    '</div>' +

    // ===== CUSTOM ORDER TAB =====
    '<div class="inv-tab-content" data-tab="custom-order" style="display:none;flex-direction:column;gap:16px;">' +
    '<div class="dashboard-card"><div class="card-header"><h2>📋 定制单信息</h2></div>' +
    '<div class="form-container"><div class="form-row" style="display:flex;flex-wrap:nowrap;gap:8px;">' +
    '<div class="form-group" style="flex:1;min-width:0;"><label style="font-size:0.78rem;white-space:nowrap;">订单号</label><input id="co-form-orderno" style="width:100%;border:2px solid #f59e0b;border-radius:4px;" placeholder="必填"></div>' +
    '<div class="form-group" style="flex:1;min-width:0;"><label style="font-size:0.78rem;white-space:nowrap;">负责人</label><input id="co-form-owner" style="width:100%;background:#f1f5f9;" readonly></div>' +
    '<div class="form-group" style="flex:1;min-width:0;"><label style="font-size:0.78rem;white-space:nowrap;">交货日期 *</label><input type="date" id="co-form-delivery" style="width:100%;border:2px solid #f59e0b;border-radius:4px;" required></div>' +
    '<input type="hidden" id="co-form-orderdate">' +
    '</div></div></div>' +
    '<div class="dashboard-card"><div class="card-header"><h2>📦 产品明细</h2></div>' +
    '<div style="overflow-x:auto;"><datalist id="co-model-suggestions"></datalist><table style="width:100%;border-collapse:collapse;font-size:12px;" id="co-items-table"><thead><tr style="background:#f1f5f9;"><th style="width:26px;padding:2px;border:1px solid #d1d5db;"></th>' +
    '<th style="padding:6px 8px;border:1px solid #d1d5db;white-space:nowrap;width:90px;">型号</th><th style="padding:6px 8px;border:1px solid #d1d5db;white-space:nowrap;">品名</th>' +
    '<th style="padding:6px 8px;border:1px solid #d1d5db;white-space:nowrap;width:100px;">产品图片</th><th style="padding:6px 8px;border:1px solid #d1d5db;white-space:nowrap;width:60px;">颜色</th>' +
    '<th style="padding:6px 8px;border:1px solid #d1d5db;white-space:nowrap;">定制需求</th><th style="padding:6px 8px;border:1px solid #d1d5db;white-space:nowrap;">单价(元/pcs)</th>' +
    '<th style="padding:6px 8px;border:1px solid #d1d5db;white-space:nowrap;">数量(pcs)</th><th style="padding:6px 8px;border:1px solid #d1d5db;white-space:nowrap;">合计</th>' +
    '<th style="padding:6px 8px;border:1px solid #d1d5db;white-space:nowrap;">备注</th></tr></thead><tbody id="co-items-body"></tbody></table></div>' +
    '<button class="btn-action" style="margin-top:8px;padding:6px 16px;font-size:0.85rem;background:#889098;color:#334155;border:none;border-radius:6px;cursor:pointer;" onclick="addCoRow()">+ 添加产品行</button></div>' +
    '<div class="dashboard-card"><div class="card-header"><h2>📊 合计</h2></div><div style="text-align:right;padding:12px;font-size:1.3rem;font-weight:800;color:#be123c;">¥ <span id="co-total-amount">0.00</span></div></div>' +
    '<div style="display:flex;gap:12px;margin-bottom:8px;"><button class="btn-action" style="flex:1;padding:14px;font-size:1.05rem;background:#6366f1;color:white;border:none;border-radius:8px;cursor:pointer;" onclick="generateCustomOrderExcel()">📊 一键生成 Excel</button>' +
    '<button class="btn-action" id="co-dl-btn" style="flex:1;padding:14px;font-size:1.05rem;background:#10b981;color:white;border:none;border-radius:8px;cursor:pointer;" onclick="downloadCustomOrderExcel()" disabled>📜 下载</button></div>' +
    '<div style="display:flex;gap:12px;"><button class="btn-action" style="flex:1;padding:14px;font-size:1.05rem;background:#f59e0b;color:white;border:none;border-radius:8px;cursor:pointer;" onclick="confirmCustomOrder()">🛒 去采购</button></div></div>' +

    // ===== SHENHAN INVOICE TAB =====
    '<div class="inv-tab-content" data-tab="shenhan-invoice" style="display:none;flex-direction:column;gap:16px;">' +
    '<div id="shi-content">加载中...</div>' +
    '</div>'

    


    console.log('[Invoice] Setting innerHTML...');
    refreshIsDropdowns();
    console.log('[Invoice] refreshIsDropdowns done');
    // refreshIsItemProdOpts(); // using datalist now
    console.log('[Invoice] refreshIsItemProdOpts done');
    addIsItem();
    console.log('[Invoice] addIsItem done');
    document.addEventListener('input', isInputHandler);
    // Auto-prefill from order (Generate Invoice feature)
    try {
        var prefillRaw = sessionStorage.getItem("efast_invoice_prefill");
        if (prefillRaw) {
            sessionStorage.removeItem("efast_invoice_prefill");
            var prefill = JSON.parse(prefillRaw);
            // Fill customer fields
            var setVal = function(id, val) { var el = document.getElementById(id); if (el) el.value = val || ""; };
            setVal("is-form-custname", prefill.buyerName);
            setVal("is-form-custattn", prefill.buyerConsignee);
            setVal("is-form-custtel", prefill.buyerPhone);
            setVal("is-form-custaddr", prefill.buyerAddress);
            // Fill products
            if (prefill.products && prefill.products.length > 0) {
                // Remove default empty item rows
                var container = document.getElementById("is-items-container");
                if (container) container.innerHTML = "";
                window._isItems = {};
                window._isCounter = 0;
                // Add each product using the existing addIsItem function
                prefill.products.forEach(function(prod) {
                    addIsItem();
                    var idx = window._isCounter - 1;
                    // Pre-set quantity and model_no so onchange reads correct values
                    if (window._isItems && window._isItems[idx]) {
                        window._isItems[idx].model_no = prod.model || '';
                        window._isItems[idx].qty = parseInt(prod.quantity) || 1;
                    }
                    // Set quantity in DOM first
                    var qtyEl = document.getElementById("is-item-qty-" + idx);
                    if (qtyEl && prod.quantity) {
                        qtyEl.value = prod.quantity;
                    }
                    // Set model (this triggers onchange → onIsItemModelChange which auto-fills price/desc/image)
                    var modelEl = document.getElementById("is-item-model-" + idx);
                    if (modelEl && prod.model) {
                        modelEl.value = prod.model;
                    }
                });
                isRefreshPreview();
            }
        }
    } catch(e) { console.warn("[Invoice] Prefill error:", e); }
    console.log('[Invoice] renderInvoiceForm COMPLETE');
    } catch(e) { c.innerHTML = '<div style="padding:40px;text-align:center;color:#ef4444;">加载失败: ' + escapeHtml(e.message) + '</div>'; console.error('[Invoice] ERROR:', e); }
}

function addIsItem() {
    var container = document.getElementById('is-items-container'); if (!container) return;
    var idx = window._isCounter++;
    window._isItems[idx] = { model_no:'', product_name:'', description:'', unit_price:0, qty:1, image_data:'' };
    var row = document.createElement('div');
    row.className = 'inv-item-row';
    row.id = 'is-item-'+idx;
    row.style.cssText = 'display:flex;align-items:flex-start;gap:6px;flex-wrap:nowrap;';
    row.innerHTML = '<div class="inv-item-col" style="width:10%;"><label>型号</label><input id="is-item-model-'+idx+'" list="is-item-datalist-'+idx+'" placeholder="输入型号..." oninput="onIsItemModelInput('+idx+')" onchange="onIsItemModelChange('+idx+')" style="width:100%;box-sizing:border-box;"><datalist id="is-item-datalist-'+idx+'"></datalist></div>' +
        '<div class="inv-item-col" style="width:20%;"><label>产品名称</label><input id="is-item-pname-'+idx+'" placeholder="产品名称" style="width:100%;"></div>' +
        '<div class="inv-item-col" style="width:20%;"><label>图片</label><div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><input type="file" accept="image/*" id="is-item-img-'+idx+'" onchange="onIsItemImg('+idx+')" style="font-size:0.65rem;width:100%;"><img id="is-item-img-prev-'+idx+'" src="" style="width:50px;height:50px;object-fit:contain;border:1px solid #e2e8f0;border-radius:4px;display:none;"></div></div>' +
        '<div class="inv-item-col" style="width:22%;"><label>描述</label><textarea id="is-item-desc-'+idx+'" placeholder="颜色/属性..." rows="1" class="auto-grow" oninput="if(window._isItems&&window._isItems['+idx+'])window._isItems['+idx+'].description=this.value" style="width:100%;padding:4px 8px;border:1px solid var(--border-color);border-radius:4px;font-size:0.85rem;box-sizing:border-box;resize:vertical;overflow:auto;min-height:34px;font-family:inherit;"></textarea></div>' +
        '<div class="inv-item-col" style="width:12%;"><label>单价</label><div style="display:flex;align-items:center;gap:2px;"><span id="is-item-hint-'+idx+'" style="color:#6b7280;font-size:0.8rem;">$</span><input type="number" step="0.01" id="is-item-price-'+idx+'" value="0.00" oninput="updateIsItemSubtotal('+idx+')" style="width:100%;-moz-appearance:textfield;""></div></div>' +
        '<div class="inv-item-col" style="width:8%;"><label>数量</label><input type="number" step="1" min="1" id="is-item-qty-'+idx+'" value="1" onchange="onIsItemQty('+idx+')" oninput="updateIsItemSubtotal('+idx+')" style="width:100%;-moz-appearance:textfield;""></div>' +
        '<div class="inv-item-col" style="width:8%;"><label>小计</label><input type="number" step="0.01" id="is-item-subtotal-'+idx+'" value="0.00" readonly style="width:100%;-moz-appearance:textfield;""></div>' +
        '<button class="remove-btn" onclick="removeIsItem('+idx+')" title="删除此行" style="flex-shrink:0;align-self:flex-start;margin-top:18px;background:#ef4444;color:#fff;border:none;border-radius:4px;cursor:pointer;padding:4px 8px;font-size:0.85rem;">✕</button>';
    container.appendChild(row);
    refreshIsItemProdOpts();
}

function removeIsItem(idx) { var row = document.getElementById('is-item-'+idx); if (row) row.remove(); delete window._isItems[idx]; isRefreshPreview(); }
function refreshIsItemProdOpts() {
    if (!window._isItems) return;
    Object.keys(window._isItems).forEach(function(idx) {
        var modelEl = document.getElementById('is-item-model-'+idx); if (!modelEl) return;
        var cv = modelEl.value;
        modelEl.value = cv;
    });
}

function onIsItemImg(idx) {
    var file = document.getElementById('is-item-img-' + idx).files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function(e) {
        document.getElementById('is-item-img-prev-' + idx).src = e.target.result;
        document.getElementById('is-item-img-prev-' + idx).style.display = 'block';
        if (window._isItems && window._isItems[idx]) {
            window._isItems[idx].image_data = e.target.result;
        }
    };
    reader.readAsDataURL(file);
}
// 型号输入联想
function onIsItemModelInput(idx) {
    var inp = document.getElementById('is-item-model-'+idx);
    var dl = document.getElementById('is-item-datalist-'+idx);
    if (!inp || !dl) return;
    var val = (inp.value || '').toLowerCase().trim();
    dl.innerHTML = '';
    if (!val) return;
    var products = ipr();
    var matches = products.filter(function(p) {
        return p.model_no && p.model_no.toLowerCase().indexOf(val) !== -1;
    }).slice(0, 10);
    matches.forEach(function(p) {
        dl.innerHTML += '<option value="' + p.model_no + '">' + (p.product_name || p.model_no) + '</option>';
    });
}
function updateIsItemSubtotal(idx) {
    var price = parseFloat(document.getElementById('is-item-price-'+idx)?.value) || 0;
    var qty = parseInt(document.getElementById('is-item-qty-'+idx)?.value) || 0;
    var subtotal = (price * qty).toFixed(2);
    var el = document.getElementById('is-item-subtotal-'+idx);
    if (el) el.value = subtotal;
    if (window._isItems && window._isItems[idx]) {
        window._isItems[idx].unit_price = price;
        window._isItems[idx].qty = qty;
    }
    if (typeof isRefreshPreview === 'function') isRefreshPreview();
}

function onIsItemModelChange(idx) {
    var inp = document.getElementById('is-item-model-'+idx);
    if (!inp) return;
    var val = (inp.value || '').trim();
    if (!val) { if (window._isItems && window._isItems[idx]) window._isItems[idx].model_no = ''; return; }
    if (window._isItems && window._isItems[idx]) window._isItems[idx].model_no = val;
    var prod = ipr().find(function(p) { return p.model_no === val; });
    if (prod) {
        if (window._isItems && window._isItems[idx]) {
            window._isItems[idx].product_name = prod.product_name || '';
            window._isItems[idx].unit_price = prod.unit_price || 0;
        }
        var pnEl = document.getElementById('is-item-pname-'+idx);
        if (pnEl) pnEl.value = prod.product_name || '';
        var descEl = document.getElementById('is-item-desc-'+idx);
        if (descEl && window._serverProducts) {
            var sp = window._serverProducts.find(function(x) { return x.model === val; });
            if (sp && sp.description) {
                descEl.value = sp.description;
                if (window._isItems && window._isItems[idx]) window._isItems[idx].description = sp.description;
            }
        }
        var imgPrev = document.getElementById('is-item-img-prev-'+idx);
        if (imgPrev && prod.image_path) {
            imgPrev.src = '/api/product-image/' + encodeURIComponent(val);
            imgPrev.style.display = 'block';
            imgPrev.onerror = function() { imgPrev.style.display = 'none'; };
        }
        var priceEl = document.getElementById('is-item-price-'+idx);
        if (priceEl) {
            var qty = parseInt(isV('is-item-qty-'+idx)) || 1;
            var price = sMatchPrice(prod, qty);
            priceEl.value = price.toFixed(2);
            if (window._isItems && window._isItems[idx]) window._isItems[idx].unit_price = price;
        }
        updateIsItemSubtotal(idx);
    }
    isRefreshPreview();
}
function onIsItemQty(idx) {
    var modelEl = document.getElementById('is-item-model-'+idx); if (!modelEl) return; var sel = modelEl.value; if (!sel) return;
    var prod = ipr().find(function(p){return p.model_no===sel;});
    if (prod && prod.price_tiers && prod.price_tiers.length) { var qty=parseInt(isV('is-item-qty-'+idx))||1, price=sMatchPrice(prod,qty);
        document.getElementById('is-item-price-'+idx).value=price.toFixed(2); window._isItems[idx].unit_price=price; window._isItems[idx].qty=qty; updateIsItemSubtotal(idx); }
    isRefreshPreview();
}

// ===== Form Handlers =====
function onIsHeaderSelect(){try{var s=isV('is-form-header');if(!s)return;var h=ih().find(function(x){return x.name===s;});if(h){var el1=document.getElementById('is-form-company'),el2=document.getElementById('is-form-contact'),el3=document.getElementById('is-form-manufacturer');if(el1)el1.value=h.company_name||'';if(el2)el2.value=h.contact||'';if(el3)el3.value=h.manufacturer_info||'';}}catch(e){console.error('onIsHeaderSelect:',e);}}
function onIsCustomerSelect(){var sel=document.getElementById('is-form-customer');if(!sel){console.warn('is-form-customer not found');return;}var s=sel.value.trim();console.log('Customer selected:',s);if(!s)return;var customers=icu();console.log('Available customers:',customers.length);var c=customers.find(function(x){return x.name===s;});if(!c){console.warn('Customer not found:',s);return;}console.log('Filling customer:',c.name);try{var f=function(id,v){var e=document.getElementById(id);if(e){e.value=v||'';}else{console.warn('Element not found:',id);}};f('is-form-custname',c.name);f('is-form-custattn',c.attn);f('is-form-custtel',c.tel);f('is-form-custaddr',(c.address||'').replace(/\\n/g,'\n'));f('is-form-custpono',c.po_no);f('is-form-cf1val',c.custom_field_1_value);f('is-form-cf2val',c.custom_field_2_value);f('is-form-cf1lbl',c.custom_field_1_label);f('is-form-cf2lbl',c.custom_field_2_label);if(c.currency){var cs=itc();if(cs.indexOf(c.currency)!==-1){f('is-form-currency',c.currency);}else{f('is-form-currency','Other');var ce=document.getElementById('is-form-custom-curr');if(ce)ce.style.display='block';f('is-form-currency-c',c.currency);}}}catch(e){console.error('onIsCustomerSelect error:',e);}}
function onIsCurrencyChange(){document.getElementById('is-form-custom-curr').style.display=isV('is-form-currency')==='Other'?'block':'none';isUpdateHints();isRefreshPreview();}
function onIsShipMethodChange(){document.getElementById('is-form-shipmethod-c').style.display=isV('is-form-shipmethod')==='__custom__'?'block':'none';}
function onIsPayTermChange(){document.getElementById('is-form-payterm-c').style.display=isV('is-form-payterm')==='__custom__'?'block':'none';}

function onIsCustnameInput(){var v=isV('is-form-custname');if(!v)return;var c=icu().find(function(x){return x.name===v;});if(!c)return;var f=function(id,val){var e=document.getElementById(id);if(e)e.value=val||'';};f('is-form-custattn',c.attn);f('is-form-custtel',c.tel);f('is-form-custaddr',(c.address||'').replace(/\\n/g,'\n'));f('is-form-custpono',c.po_no);f('is-form-cf1val',c.custom_field_1_value);f('is-form-cf2val',c.custom_field_2_value);f('is-form-cf1lbl',c.custom_field_1_label);f('is-form-cf2lbl',c.custom_field_2_label);}
function onIsPaymentSelect() {
    var name = document.getElementById('is-form-payment').value;
    if (!name) {
        document.getElementById('is-form-paytext').value = '';
        document.getElementById('is-form-payimg').style.display = 'none';
        return;
    }
    var payments = ipa();
    var p = payments.find(function(x) { return x.name === name; });
    if (!p) return;
    document.getElementById('is-form-paytext').value = p.text || '';
    var imgEl = document.getElementById('is-form-payimg');
    if (p.image_path) {
        imgEl.src = '/api/payment-image/' + p.image_path;
        imgEl.style.display = 'block';
        return;
    }
    imgEl.style.display = 'none';
}
function onIsShipTermChange(){var v=isV('is-form-shipterm');document.getElementById('is-form-shipterm-p').style.display=(v&&v!=='__custom__')?'block':'none';document.getElementById('is-form-shipterm-c').style.display=v==='__custom__'?'block':'none';if(v&&v!=='__custom__')document.getElementById('is-form-shipterm-pl').textContent=['FOB','EXW'].indexOf(v)!==-1?'装运地 (Loading Place)':'目的地 (Destination)';}

function isGetCcySymbol(){var v=isV('is-form-currency'),m={USD:'$',RMB:'¥',CNY:'¥',EUR:'€',GBP:'£',HKD:'HK$',JPY:'¥'};if(v==='Other')return isV('is-form-currency-s')||'$';return m[v]||'$';}
function isGetCcyCode(){var v=isV('is-form-currency');if(v==='Other')return isV('is-form-currency-c')||'USD';return v;}
function isGetPayTerm(){var v=isV('is-form-payterm');if(v==='__custom__')return isV('is-form-payterm-c');return v;}
function isGetShipTerm(){var v=isV('is-form-shipterm');if(v==='__custom__')return isV('is-form-shipterm-c');if(!v)return'';return (v+' '+isV('is-form-shipterm-pv')).trim();}
function isGetShipMethod(){var v=isV('is-form-shipmethod');if(v==='__custom__')return isV('is-form-shipmethod-c');return v;}
function isUpdateHints(){var s=isGetCcySymbol();Object.keys(window._isItems||{}).forEach(function(idx){var e=document.getElementById('is-item-hint-'+idx);if(e)e.textContent=s;});}
async function isImportCRM(){var name=isV('is-form-custname');if(!name){sT('请先填写客户名称','error');return;}var tel=isV('is-form-custtel');var attn=isV('is-form-custattn');var addr=isV('is-form-custaddr');try{var token=typeof Auth!=='undefined'&&Auth.getToken?Auth.getToken():localStorage.getItem('efast_token');var resp=await fetch('/api/customers',{headers:{'Authorization':'Bearer '+token}});if(!resp.ok)throw new Error('获取客户列表失败');var cdata=await resp.json();var customers=cdata.customers||[];var existing=customers.find(function(c){return c.company===name;});if(existing){if(existing.phone===tel){var upResp=await fetch('/api/customers/'+existing.id,{method:'PUT',headers:{'Content-Type':'application/json','Authorization':'Bearer '+token},body:JSON.stringify({contact:attn,phone:tel,address:addr})});if(!upResp.ok)throw new Error('保存失败');sT('客户 "'+name+'" 已更新到CRM！','success');}else{var newResp=await fetch('/api/customers',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+token},body:JSON.stringify({company:name,contact:attn,phone:tel,address:addr,star:'L3'})});if(!newResp.ok)throw new Error('????');sT('客户 "'+name+'" 已新建到CRM！（电话与已有客户不同）','success');}}else{var newResp=await fetch('/api/customers',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+token},body:JSON.stringify({company:name,contact:attn,phone:tel,address:addr,star:'L3'})});if(!newResp.ok)throw new Error('????');sT('客户 "'+name+'" 已新建到CRM！','success');}}catch(e){sT('导入CRM失败: '+e.message,'error');console.error(e);}}
async function isGenerateOrder(){var invoiceNo=isV('is-form-invoiceno');if(!invoiceNo){sT('请先填写单号','error');return;}var custName=isV('is-form-custname');if(!custName){sT('请先填写客户名称','error');return;}var items=window._isItems||{};var vi=Object.values(items).filter(function(i){return i.model_no&&i.model_no.trim();});var sub=0;vi.forEach(function(i){sub+=(i.unit_price||0)*(i.qty||1);});var sh=parseFloat(isV('is-form-shippingcost'))||0;var total=sub+sh;var products=vi.map(function(i){var mn=i.model_no.trim();var fp=window._serverProducts?window._serverProducts.find(function(p){return(p.model||p.model_no)===mn;}):null;if(!fp)fp=ipr().find(function(p){return p.model_no===mn;});var pn=i.product_name||(fp?(fp.productName||fp.product_name||''):'')||'';return{model:mn,erpModel:mn,title:(mn+' '+pn).trim(),name:pn,qty:i.qty||1,price:i.unit_price||0};});var order={id:invoiceNo,isSelfOrder:true,buyerName:custName,buyerPhone:isV('is-form-custtel'),buyerAddress:isV('is-form-custaddr'),amount:isGetCcySymbol()+' '+total.toFixed(2),products:products,date:isV('is-form-date')||new Date().toISOString().split('T')[0],currency:isGetCcyCode(),salesperson:(Auth.getUser()||{}).displayName||(Auth.getUser()||{}).username||''};try{var token=typeof Auth!=='undefined'&&Auth.getToken?Auth.getToken():localStorage.getItem('efast_token');var resp=await fetch('/api/orders',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+token},body:JSON.stringify(order)});if(!resp.ok){var ed=await resp.json();throw new Error(ed.error||'保存失败');}sT('订单 "'+invoiceNo+'" 已生成到自建订单！','success');}catch(e){sT('生成订单失败: '+e.message,'error');console.error(e);}}
function isRefreshPreview(){var s=isGetCcySymbol(),items=window._isItems||{},sub=0;Object.values(items).forEach(function(i){if(i.model_no)sub+=(i.unit_price||0)*(i.qty||1);});var sh=parseFloat(isV('is-form-shippingcost'))||0,t=sub+sh;var e=document.getElementById('is-form-preview');if(e)e.innerHTML=s+' '+sub.toFixed(2)+' + 运费 '+s+' '+sh.toFixed(2)+' = <span style="color:#fff;">'+s+' '+t.toFixed(2)+'</span>';}

function isInputHandler(e) {
    if (!e.target.id) return;
    var id = e.target.id;
    if (id.indexOf('is-item-price-')===0||id.indexOf('is-item-qty-')===0||id==='is-form-shippingcost') { var idx=id.split('-').pop(); if(window._isItems&&window._isItems[idx]){ if(id.indexOf('price')!==-1)window._isItems[idx].unit_price=parseFloat(e.target.value)||0; if(id.indexOf('qty')!==-1)window._isItems[idx].qty=parseInt(e.target.value)||1; } isRefreshPreview(); }
    if (id.indexOf('is-item-model-')===0) { var i=id.split('-').pop(); if(window._isItems&&window._isItems[i]){window._isItems[i].model_no=e.target.value;} }
    if (id.indexOf('is-item-desc-')===0) { var i=id.split('-').pop(); if(window._isItems&&window._isItems[i])window._isItems[i].description=e.target.value; }
    if (id.indexOf('is-item-pname-')===0) { var i=id.split('-').pop(); if(window._isItems&&window._isItems[i])window._isItems[i].product_name=e.target.value; }
    if (id==='is-form-currency'||id==='is-form-currency-s') { isUpdateHints(); isRefreshPreview(); }
}



// ===== Incoterm 下拉框初始化 =====
function initIncotermDropdowns() {
    var terms = its();
    var defaultTerm = 'FOB';
    ['sq-form-incoterm', 'cq-form-incoterm'].forEach(function(id) {
        var sel = document.getElementById(id);
        if (!sel) return;
        var cur = sel.value || defaultTerm;
        sel.innerHTML = '';
        terms.forEach(function(t) {
            sel.innerHTML += '<option value="' + t + '">' + t + '</option>';
        });
        sel.value = cur || terms[0] || defaultTerm;
    });
}
var _sqCounter = 0;
var _sqItems = {};
function addSqItem() {
    var container = document.getElementById('sq-items-container'); if (!container) return;
    var idx = _sqCounter++;
    _sqItems[idx] = { model_no:'', product_name:'', description:'', unit_price:0, qty:1, image_data:'', packaging:'', tiers:[] };
    var row = document.createElement('div');
    row.className = 'inv-item-row';
    row.id = 'sq-item-'+idx;
    row.style.cssText = 'display:flex;align-items:flex-start;gap:6px;width:100%;';
    var h = '';
    h += '<div class="inv-item-col" style="width:80px;flex-shrink:0;"><label>型号</label><input id="sq-item-model-'+idx+'" list="sq-item-datalist-'+idx+'" placeholder="型号..." oninput="onSqItemModelInput('+idx+')" onchange="onSqItemModelChange('+idx+')" style="width:100%;box-sizing:border-box;"><datalist id="sq-item-datalist-'+idx+'"></datalist></div>';
    h += '<div class="inv-item-col" style="width:120px;flex-shrink:0;"><label>图片</label><div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><input type="file" accept="image/*" id="sq-item-img-'+idx+'" onchange="onSqItemImg('+idx+')" style="font-size:0.65rem;width:100%;"><img id="sq-item-img-prev-'+idx+'" src="" style="width:50px;height:50px;object-fit:contain;border:1px solid #e2e8f0;border-radius:4px;display:none;"></div></div>';
    h += '<div class="inv-item-col" style="flex:1;min-width:150px;"><label>描述与规格</label><textarea id="sq-item-desc-'+idx+'" placeholder="描述..." rows="2" class="auto-grow" oninput="if(_sqItems['+idx+'])_sqItems['+idx+'].description=this.value" style="width:100%;padding:4px 8px;border:1px solid var(--border-color);border-radius:4px;font-size:0.8rem;box-sizing:border-box;resize:vertical;overflow:auto;min-height:34px;font-family:inherit;"></textarea></div>';
    h += '<div class="inv-item-col" style="width:75px;flex-shrink:0;"><label>数量</label>';
    for (var t = 0; t < 4; t++) {
        h += '<input id="sq-item-qty'+t+'-'+idx+'" placeholder="Qty'+(t+1)+'" oninput="if(_sqItems['+idx+']){if(!_sqItems['+idx+'].tiers)_sqItems['+idx+'].tiers=[];_sqItems['+idx+'].tiers['+t+']=_sqItems['+idx+'].tiers['+t+']||{};_sqItems['+idx+'].tiers['+t+'].qty=this.value;}" style="width:100%;box-sizing:border-box;margin-bottom:2px;font-size:0.75rem;">';
    }
    h += '</div>';
    h += '<div class="inv-item-col" style="width:75px;flex-shrink:0;"><label>单价(US$)</label>';
    for (var t = 0; t < 4; t++) {
        h += '<input id="sq-item-price'+t+'-'+idx+'" placeholder="$" oninput="if(_sqItems['+idx+']){if(!_sqItems['+idx+'].tiers)_sqItems['+idx+'].tiers=[];_sqItems['+idx+'].tiers['+t+']=_sqItems['+idx+'].tiers['+t+']||{};_sqItems['+idx+'].tiers['+t+'].price=this.value;}" style="width:100%;box-sizing:border-box;margin-bottom:2px;font-size:0.75rem;">';
    }
    h += '</div>';
    h += '<div class="inv-item-col" style="width:160px;flex-shrink:0;"><label>包装详情</label><textarea id="sq-item-packaging-'+idx+'" placeholder="Unit Weight: ..." rows="3" oninput="if(_sqItems['+idx+'])_sqItems['+idx+'].packaging=this.value" style="width:100%;padding:4px 8px;border:1px solid var(--border-color);border-radius:4px;font-size:0.75rem;box-sizing:border-box;resize:vertical;overflow:auto;min-height:50px;font-family:inherit;"></textarea></div>';
    h += '<button class="remove-btn" onclick="removeSqItem('+idx+')" title="删除" style="flex-shrink:0;align-self:flex-start;margin-top:18px;background:#ef4444;color:#fff;border:none;border-radius:4px;cursor:pointer;padding:4px 8px;font-size:0.85rem;">✕</button>';
    row.innerHTML = h;
    container.appendChild(row);
    refreshSqItemOpts();
}
function removeSqItem(idx) { var row = document.getElementById("sq-item-"+idx); if (row) row.remove(); delete _sqItems[idx]; }
function refreshSqItemOpts() {
    Object.keys(_sqItems).forEach(function(idx) {
        var modelEl = document.getElementById("sq-item-model-"+idx); if (!modelEl) return;
        var dl = document.getElementById("sq-item-datalist-"+idx); if (!dl) return;
        var val = modelEl.value.toLowerCase();
        dl.innerHTML = "";
        if (val.length < 1) return;
        ipr().filter(function(p){ return p.model_no && p.model_no.toLowerCase().indexOf(val) !== -1; }).slice(0, 10).forEach(function(p){
            var opt = document.createElement("option"); opt.value = p.model_no; dl.appendChild(opt);
        });
    });
}
function onSqItemModelInput(idx) {
    var inp = document.getElementById("sq-item-model-"+idx);
    var dl = document.getElementById("sq-item-datalist-"+idx);
    if (!inp || !dl) return;
    if (_sqItems[idx]) _sqItems[idx].model_no = inp.value;
    var val = inp.value.toLowerCase();
    dl.innerHTML = "";
    if (val.length < 1) return;
    ipr().filter(function(p){ return p.model_no && p.model_no.toLowerCase().indexOf(val) !== -1; }).slice(0, 10).forEach(function(p){
        var opt = document.createElement("option"); opt.value = p.model_no; dl.appendChild(opt);
    });
}
function onSqItemModelChange(idx) {
    var inp = document.getElementById('sq-item-model-'+idx); if (!inp) return;
    var val = inp.value.trim(); if (!val) return;
    if (_sqItems[idx]) _sqItems[idx].model_no = val;
    var prod = ipr().find(function(p){ return p.model_no === val; });
    if (prod) {
        if (_sqItems[idx]) { _sqItems[idx].product_name = prod.product_name || ''; _sqItems[idx].description = prod.description || ''; }
        var descEl = document.getElementById('sq-item-desc-'+idx);
        if (descEl && prod.description) descEl.value = prod.description;
        // Tiers
        var tiers = prod.price_tiers || [];
        if (_sqItems[idx]) _sqItems[idx].tiers = [];
        for (var t = 0; t < 4; t++) {
            var qtyEl = document.getElementById('sq-item-qty'+t+'-'+idx);
            var priceEl = document.getElementById('sq-item-price'+t+'-'+idx);
            if (t < tiers.length) {
                var tier = tiers[t];
                var qtyVal = tier.min_qty ? tier.min_qty : (tier.qty || '');
                var priceVal = tier.price || '';
                if (qtyEl) qtyEl.value = qtyVal;
                if (priceEl) priceEl.value = priceVal;
                if (_sqItems[idx] && _sqItems[idx].tiers) _sqItems[idx].tiers[t] = {qty: qtyVal, price: priceVal};
            } else {
                if (qtyEl) qtyEl.value = '';
                if (priceEl) priceEl.value = '';
            }
        }
        // Packaging
        var pkgLines = [];
        if (prod.weight) pkgLines.push('Unit Weight: ' + prod.weight + ' g');
        if (prod.dimensions) { var ds = prod.dimensions; pkgLines.push('Product Size: ' + ds + (ds.toLowerCase().indexOf('cm')>=0 ? '' : ' cm')); }
        if (prod.packingQty) { var pq = String(prod.packingQty); pkgLines.push(pq.toUpperCase().indexOf('CTN')>=0 ? pq : pq + '/CTN'); }
        if (prod.cartonWeight) pkgLines.push('Carton Weight: ' + prod.cartonWeight + ' kg');
        if (prod.cartonSize) { var cs = prod.cartonSize; pkgLines.push('Carton Size: ' + cs + (cs.toLowerCase().indexOf('cm')>=0 ? '' : ' cm')); }
        var pkgText = pkgLines.join('\n');
        if (_sqItems[idx]) _sqItems[idx].packaging = pkgText;
        var pkgEl = document.getElementById('sq-item-packaging-'+idx);
        if (pkgEl) pkgEl.value = pkgText;
        // Image: fetch from server and convert to base64
        (function(imgIdx, modelVal){
            var imgPrev = document.getElementById('sq-item-img-prev-'+imgIdx);
            var imgUrl = '/api/product-image/' + encodeURIComponent(modelVal);
            fetch(imgUrl).then(function(resp){
                if (!resp.ok) throw new Error('no image');
                return resp.blob();
            }).then(function(blob){
                var reader = new FileReader();
                reader.onload = function(){
                    var dataUrl = reader.result;
                    if (imgPrev) { imgPrev.src = dataUrl; imgPrev.style.display = 'block'; }
                    if (_sqItems && _sqItems[imgIdx]) _sqItems[imgIdx].image_data = dataUrl;
                };
                reader.readAsDataURL(blob);
            }).catch(function(){
                if (imgPrev) imgPrev.style.display = 'none';
            });
        })(idx, val);
    }
}
function onSqItemImg(idx) {
    var file = document.getElementById("sq-item-img-" + idx).files[0]; if (!file) return;
    var reader = new FileReader();
    reader.onload = function(e) { document.getElementById("sq-item-img-prev-" + idx).src = e.target.result; document.getElementById("sq-item-img-prev-" + idx).style.display = "block"; if (_sqItems && _sqItems[idx]) _sqItems[idx].image_data = e.target.result; };
    reader.readAsDataURL(file);
}
function onSqHeaderSelect() {
    var s = (document.getElementById("sq-form-header")||{}).value; if (!s) return;
    var h = ih().find(function(x) { return x.name === s; });
    if (h) { var e2=document.getElementById("sq-form-contact"); if(e2)e2.value=h.contact||""; }
}

var _cqCounter = 0;
var _cqItems = {};
function addCqItem() {
    var container = document.getElementById('cq-items-container'); if (!container) return;
    var idx = _cqCounter++;
    _cqItems[idx] = { model_no:'', product_name:'', description:'', unit_price:0, qty:1, image_data:'', lead_time:'', packaging:'' };
    var row = document.createElement('div');
    row.className = 'inv-item-row';
    row.id = 'cq-item-'+idx;
    row.style.cssText = 'display:flex;align-items:flex-start;gap:6px;width:100%;';
    var h = '';
    h += '<div class="inv-item-col" style="width:80px;flex-shrink:0;"><label>型号</label><input id="cq-item-model-'+idx+'" list="cq-item-datalist-'+idx+'" placeholder="型号..." oninput="onCqItemModelInput('+idx+')" onchange="onCqItemModelChange('+idx+')" style="width:100%;box-sizing:border-box;"><datalist id="cq-item-datalist-'+idx+'"></datalist></div>';
    h += '<div class="inv-item-col" style="width:110px;flex-shrink:0;"><label>图片</label><div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><input type="file" accept="image/*" id="cq-item-img-'+idx+'" onchange="onCqItemImg('+idx+')" style="font-size:0.65rem;width:100%;"><img id="cq-item-img-prev-'+idx+'" src="" style="width:50px;height:50px;object-fit:contain;border:1px solid #e2e8f0;border-radius:4px;display:none;"></div></div>';
    h += '<div class="inv-item-col" style="flex:1;min-width:150px;"><label>描述与定制</label><textarea id="cq-item-desc-'+idx+'" placeholder="描述..." rows="2" class="auto-grow" oninput="if(_cqItems['+idx+'])_cqItems['+idx+'].description=this.value" style="width:100%;padding:4px 8px;border:1px solid var(--border-color);border-radius:4px;font-size:0.8rem;box-sizing:border-box;resize:vertical;overflow:auto;min-height:34px;font-family:inherit;"></textarea></div>';
    h += '<div class="inv-item-col" style="width:80px;flex-shrink:0;"><label>数量</label><input id="cq-item-qty-'+idx+'" placeholder="Qty" oninput="if(_cqItems['+idx+'])_cqItems['+idx+'].qty=this.value" style="width:100%;box-sizing:border-box;"></div>';
    h += '<div class="inv-item-col" style="width:80px;flex-shrink:0;"><label>单价(US$)</label><input id="cq-item-price-'+idx+'" placeholder="Price" oninput="if(_cqItems['+idx+'])_cqItems['+idx+'].unit_price=this.value" style="width:100%;box-sizing:border-box;"></div>';
    h += '<div class="inv-item-col" style="width:85px;flex-shrink:0;"><label>交期</label><input id="cq-item-leadtime-'+idx+'" placeholder="e.g. 15d" oninput="if(_cqItems['+idx+'])_cqItems['+idx+'].lead_time=this.value" style="width:100%;box-sizing:border-box;"></div>';
    h += '<div class="inv-item-col" style="width:160px;flex-shrink:0;"><label>包装详情</label><textarea id="cq-item-packaging-'+idx+'" placeholder="Unit Weight: ..." rows="3" oninput="if(_cqItems['+idx+'])_cqItems['+idx+'].packaging=this.value" style="width:100%;padding:4px 8px;border:1px solid var(--border-color);border-radius:4px;font-size:0.75rem;box-sizing:border-box;resize:vertical;overflow:auto;min-height:50px;font-family:inherit;"></textarea></div>';
    h += '<button class="remove-btn" onclick="removeCqItem('+idx+')" title="删除" style="flex-shrink:0;align-self:flex-start;margin-top:18px;background:#ef4444;color:#fff;border:none;border-radius:4px;cursor:pointer;padding:4px 8px;font-size:0.85rem;">✕</button>';
    row.innerHTML = h;
    container.appendChild(row);
    refreshCqItemOpts();
}
function removeCqItem(idx) { var row = document.getElementById("cq-item-"+idx); if (row) row.remove(); delete _cqItems[idx]; }
function refreshCqItemOpts() {
    Object.keys(_cqItems).forEach(function(idx) {
        var modelEl = document.getElementById("cq-item-model-"+idx); if (!modelEl) return;
        var dl = document.getElementById("cq-item-datalist-"+idx); if (!dl) return;
        var val = modelEl.value.toLowerCase();
        dl.innerHTML = "";
        if (val.length < 1) return;
        ipr().filter(function(p){ return p.model_no && p.model_no.toLowerCase().indexOf(val) !== -1; }).slice(0, 10).forEach(function(p){
            var opt = document.createElement("option"); opt.value = p.model_no; dl.appendChild(opt);
        });
    });
}
function onCqItemModelInput(idx) {
    var inp = document.getElementById("cq-item-model-"+idx);
    var dl = document.getElementById("cq-item-datalist-"+idx);
    if (!inp || !dl) return;
    if (_cqItems[idx]) _cqItems[idx].model_no = inp.value;
    var val = inp.value.toLowerCase();
    dl.innerHTML = "";
    if (val.length < 1) return;
    ipr().filter(function(p){ return p.model_no && p.model_no.toLowerCase().indexOf(val) !== -1; }).slice(0, 10).forEach(function(p){
        var opt = document.createElement("option"); opt.value = p.model_no; dl.appendChild(opt);
    });
}
function onCqItemModelChange(idx) {
    var inp = document.getElementById('cq-item-model-'+idx); if (!inp) return;
    var val = inp.value.trim(); if (!val) return;
    if (_cqItems[idx]) _cqItems[idx].model_no = val;
    var prod = ipr().find(function(p){ return p.model_no === val; });
    if (prod) {
        if (_cqItems[idx]) { _cqItems[idx].product_name = prod.product_name || ''; _cqItems[idx].description = prod.description || ''; }
        var descEl = document.getElementById('cq-item-desc-'+idx);
        if (descEl && prod.description) descEl.value = prod.description;
        // First tier qty + price
        var tiers = prod.price_tiers || [];
        var qtyEl = document.getElementById('cq-item-qty-'+idx);
        var priceEl = document.getElementById('cq-item-price-'+idx);
        if (tiers.length > 0) {
            if (qtyEl) qtyEl.value = tiers[0].min_qty || tiers[0].qty || '';
            if (priceEl) priceEl.value = tiers[0].price || '';
        } else {
            if (qtyEl) qtyEl.value = 1;
            if (priceEl) priceEl.value = (prod.unit_price || 0).toFixed(2);
        }
        // Packaging
        var pkgLines = [];
        if (prod.weight) pkgLines.push('Unit Weight: ' + prod.weight + ' g');
        if (prod.dimensions) { var ds = prod.dimensions; pkgLines.push('Product Size: ' + ds + (ds.toLowerCase().indexOf('cm')>=0 ? '' : ' cm')); }
        if (prod.packingQty) { var pq = String(prod.packingQty); pkgLines.push(pq.toUpperCase().indexOf('CTN')>=0 ? pq : pq + '/CTN'); }
        if (prod.cartonWeight) pkgLines.push('Carton Weight: ' + prod.cartonWeight + ' kg');
        if (prod.cartonSize) { var cs = prod.cartonSize; pkgLines.push('Carton Size: ' + cs + (cs.toLowerCase().indexOf('cm')>=0 ? '' : ' cm')); }
        var pkgText = pkgLines.join('\n');
        if (_cqItems[idx]) _cqItems[idx].packaging = pkgText;
        var pkgEl = document.getElementById('cq-item-packaging-'+idx);
        if (pkgEl) pkgEl.value = pkgText;
        // Image: fetch from server and convert to base64
        (function(imgIdx, modelVal){
            var imgPrev = document.getElementById('cq-item-img-prev-'+imgIdx);
            var imgUrl = '/api/product-image/' + encodeURIComponent(modelVal);
            fetch(imgUrl).then(function(resp){
                if (!resp.ok) throw new Error('no image');
                return resp.blob();
            }).then(function(blob){
                var reader = new FileReader();
                reader.onload = function(){
                    var dataUrl = reader.result;
                    if (imgPrev) { imgPrev.src = dataUrl; imgPrev.style.display = 'block'; }
                    if (_cqItems && _cqItems[imgIdx]) _cqItems[imgIdx].image_data = dataUrl;
                };
                reader.readAsDataURL(blob);
            }).catch(function(){
                if (imgPrev) imgPrev.style.display = 'none';
            });
        })(idx, val);
    }
}
function onCqItemImg(idx) {
    var file = document.getElementById("cq-item-img-" + idx).files[0]; if (!file) return;
    var reader = new FileReader();
    reader.onload = function(e) { document.getElementById("cq-item-img-prev-" + idx).src = e.target.result; document.getElementById("cq-item-img-prev-" + idx).style.display = "block"; if (_cqItems && _cqItems[idx]) _cqItems[idx].image_data = e.target.result; };
    reader.readAsDataURL(file);
}
function onCqHeaderSelect() {
    var s = (document.getElementById("cq-form-header")||{}).value; if (!s) return;
    var h = ih().find(function(x) { return x.name === s; });
    if (h) { var e2=document.getElementById("cq-form-contact"); if(e2)e2.value=h.contact||""; }
}
// ===== 下载最近生成的发票 =====
function isDownloadLast() {
    if (!window._lastInvoiceBlob) { sT('请先生成发票', 'warning'); return; }
    var url = URL.createObjectURL(window._lastInvoiceBlob);
    var a = document.createElement('a');
    a.href = url;
    a.download = 'Invoice_' + (window._lastInvoiceNo || 'download') + '.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    sT('下载成功', 'success');
}

// ===== Generate =====
async function isGenerate() {
    var dt=(isV('is-form-doctype')==='COMMERCIAL INVOICE')?'Commercial Invoice':'Proforma Invoice';
    var items=window._isItems||{},vi=Object.values(items).filter(function(i){return i.model_no&&i.model_no.trim();});if(!vi.length){sT('请至少填写一个产品型号','error');return;}
    var pt=isGetPayTerm();if(!pt.trim()){sT('付款条件必填','error');return;}
    var st=isGetShipTerm();if(!st.trim()){sT('贸易术语必填','error');return;}
    var ccy=isGetCcyCode(),sym=isGetCcySymbol(),sh=parseFloat(isV('is-form-shippingcost'))||0;
    var data={currency:ccy,company_name:isV('is-form-company'),company_contact:isV('is-form-contact'),invoice_type:dt,invoice_no:isV('is-form-invoiceno'),invoice_date:isFmtDate(isV('is-form-date')),customer:{name:isV('is-form-custname'),attn:isV('is-form-custattn'),tel:isV('is-form-custtel'),address:isV('is-form-custaddr'),po_no:isV('is-form-custpono'),terms_of_payment:pt,shipping_term:st,custom_field_1_label:isV('is-form-cf1lbl'),custom_field_1_value:isV('is-form-cf1val'),custom_field_2_label:isV('is-form-cf2lbl'),custom_field_2_value:isV('is-form-cf2val')},items:vi.map(function(i){return{model_no:i.model_no.trim(),product_name:i.product_name||'',description:i.description||'',unit_price:i.unit_price||0,qty:i.qty||1,image_data:i.image_data||''};}),shipping_method:isGetShipMethod(),shipping_cost:sh,remarks:isV('is-form-remarks'),payment_info:{account_name:isV('is-form-payment'),text:isV('is-form-paytext'),image_data:''},manufacturer_info:isV('is-form-manufacturer')};
    // Load payment QR as base64 if from server URL
    var payImgEl = document.getElementById('is-form-payimg');
    if (payImgEl && payImgEl.src && payImgEl.src.indexOf('data:') !== 0 && payImgEl.src.indexOf('/api/payment-image/') !== -1) {
        try {
            var resp = await fetch(payImgEl.src);
            var blob = await resp.blob();
            var reader = new FileReader();
            var b64 = await new Promise(function(resolve) { reader.onload = function() { resolve(reader.result); }; reader.readAsDataURL(blob); });
            data.payment_info.image_data = b64;
        } catch(e) { console.warn('Failed to load payment QR as base64:', e); }
    }
    isGenerateExcel(data);
}
function isFmtDate(d){var dd=new Date(d),day=dd.getDate(),sf='th',m=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];if(day%10===1&&day!==11)sf='st';else if(day%10===2&&day!==12)sf='nd';else if(day%10===3&&day!==13)sf='rd';return day+sf+' '+m[dd.getMonth()]+'. '+dd.getFullYear();}

// ===== Excel Generator =====

function isGenerateExcel(data, cs) {
    var ExcelJS = window.ExcelJS;
    if (!ExcelJS) { alert('ExcelJS not loaded'); return; }

    var items = data.items.filter(function(i) { return i.model_no && i.model_no.trim(); });
    var N = items.length;
    var productRow = 14; // Template product row (R14)
    var ws = null;
    var wb = null;
    var nf = '#,##0.00';

    function gC(r, c) { return ws.getRow(r).getCell(c); }

    // Helper: convert image URL to base64 data URL
    function fetchImageAsBase64(url) {
        return fetch(url).then(function(r) {
            if (!r.ok) return null;
            return r.blob();
        }).then(function(blob) {
            if (!blob) return null;
            return new Promise(function(resolve) {
                var reader = new FileReader();
                reader.onloadend = function() { resolve(reader.result); };
                reader.readAsDataURL(blob);
            });
        }).catch(function() { return null; });
    }

    // Fetch all product images in parallel
    var imagePromises = items.map(function(item) {
        var url = '/api/product-image/' + encodeURIComponent(item.model_no);
        return fetchImageAsBase64(url);
    });

    Promise.all(imagePromises).then(function(productImages) {

    var tplUrl = (data.invoice_type === 'Commercial Invoice') ? '/api/template/commercial' : '/api/template/proforma';
    fetch(tplUrl)
        .then(function(r) { if (!r.ok) throw new Error('模板加载失败'); return r.arrayBuffer(); })
        .then(function(buf) { wb = new ExcelJS.Workbook(); return wb.xlsx.load(buf).then(function() { return wb; }); })
        .then(function(_wb) {
            ws = _wb.getWorksheet(1);

            // ========== Save template row 14 style ==========
            var tplRow = ws.getRow(productRow);
            var tplStyles = [];
            for (var c = 1; c <= 6; c++) {
                var cell = tplRow.getCell(c);
                tplStyles.push({
                    style: cell.style ? JSON.parse(JSON.stringify(cell.style)) : {},
                    numFmt: cell.numFmt,
                    font: cell.font ? JSON.parse(JSON.stringify(cell.font)) : null,
                    alignment: cell.alignment ? JSON.parse(JSON.stringify(cell.alignment)) : null,
                    fill: cell.fill ? JSON.parse(JSON.stringify(cell.fill)) : null,
                    border: cell.border ? JSON.parse(JSON.stringify(cell.border)) : null
                });
            }
            var tplHeight = tplRow.height || 130;

            if (N > 1) {
                var shift = N - 1;

                // Save footer merges before spliceRows (spliceRows does NOT preserve them)
                var footerMerges = [];
                if (ws.model && ws.model.merges) {
                    footerMerges = ws.model.merges.filter(function(m) {
                        return m.split(':').some(function(part) {
                            return parseInt(part.replace(/[A-Z]/g, '')) > productRow;
                        });
                    });
                    // Unmerge originals to clear cell-level state
                    footerMerges.forEach(function(m) {
                        try { ws.unMergeCells(m); } catch(e) {}
                    });
                }

                // Insert blank rows — auto-shifts cell data/styles correctly
                var blanks = new Array(shift).fill([]);
                ws.spliceRows(productRow + 1, 0, ...blanks);

                // Rebuild footer merges at shifted positions
                if (ws.model && ws.model.merges) {
                    // Remove any leftover footer merges from model
                    ws.model.merges = ws.model.merges.filter(function(m) {
                        return m.split(':').every(function(part) {
                            return parseInt(part.replace(/[A-Z]/g, '')) <= productRow;
                        });
                    });
                }
                footerMerges.forEach(function(m) {
                    var parts = m.split(':');
                    var newParts = parts.map(function(p) {
                        var col = p.replace(/\d/g, '');
                        var num = parseInt(p.replace(/[A-Z]/g, ''));
                        return col + (num + shift);
                    });
                    var range = newParts[0] + ':' + newParts[1];
                    try { ws.unMergeCells(range); } catch(e) {}
                    ws.mergeCells(range);
                });
            }

            // Copy row 14 style to all product rows
            for (var i = 0; i < N; i++) {
                var pr = ws.getRow(productRow + i);
                for (var j = 0; j < 6; j++) {
                    var pc = pr.getCell(j + 1);
                    var ts = tplStyles[j];
                    pc.style = JSON.parse(JSON.stringify(ts.style));
                    pc.numFmt = ts.numFmt || '';
                    if (ts.font) pc.font = JSON.parse(JSON.stringify(ts.font));
                    if (ts.alignment) pc.alignment = JSON.parse(JSON.stringify(ts.alignment));
                    if (ts.fill) pc.fill = JSON.parse(JSON.stringify(ts.fill));
                    if (ts.border) pc.border = JSON.parse(JSON.stringify(ts.border));
                }
                pr.height = tplHeight;
            }

            // ========== PART 1: Fill header data ==========
            
                        if (data.company_contact) { gC(3, 1).value = data.company_contact; }
            if (data.customer) {
                gC(6, 2).value = data.customer.name || '';
                gC(6, 5).value = data.customer.po_no || '';
                gC(7, 2).value = data.customer.attn || '';
                gC(8, 2).value = data.customer.tel || '';
                gC(9, 2).value = (data.customer.address || '').replace(/\n/g, ', ');
                gC(10, 2).value = data.customer.terms_of_payment || '';
                gC(10, 5).value = data.customer.shipping_term || '';
            }
            gC(7, 5).value = data.invoice_no || '';
            gC(8, 5).value = data.invoice_date || '';
            gC(9, 5).value = data.shipping_method || '';

            // ========== PART 2: Fill product data ==========
            for (var pi = 0; pi < N; pi++) {
                var item = items[pi];
                // Col 1: Model No + Product Name
                gC(productRow + pi, 1).value = (item.model_no || '') + '\n' + (item.product_name || '');
                // Col 2: Product image (embedded)
                if (productImages && productImages[pi]) {
                    var imgBase64 = productImages[pi].split(',')[1] || productImages[pi];
                    var imgId = wb.addImage({ base64: imgBase64, extension: 'png' });
                    ws.addImage(imgId, {
                        tl: { col: 1.05, row: productRow + pi - 0.95 },
                        ext: { width: 157.34, height: 157.34 },
                        editAs: 'oneCell'
                    });
                }
                // Col 3: Description
                gC(productRow + pi, 3).value = item.description || '';
                // Col 4: Unit Price
                gC(productRow + pi, 4).value = item.unit_price || 0;
                gC(productRow + pi, 4).numFmt = nf;
                // Col 5: Qty
                gC(productRow + pi, 5).value = item.qty || 1;
                // Col 6: Amount
                gC(productRow + pi, 6).value = (item.unit_price || 0) * (item.qty || 1);
                gC(productRow + pi, 6).numFmt = nf;
            }

            // Shipping cost
            var scRow = productRow + N;
            gC(scRow, 6).value = data.shipping_cost || 0;
            gC(scRow, 6).numFmt = nf;

            // Total
            var totalRow = scRow + 1;
            gC(totalRow, 6).value = { formula: 'SUM(F' + productRow + ':F' + scRow + ')' };
            gC(totalRow, 6).numFmt = nf;

            // ========== PART 3: Footer ==========
            gC(totalRow + 3, 1).value = data.remarks || '';

            var payLabelRow = totalRow + 2;
            var payName = (data.payment_info && data.payment_info.account_name || '').toLowerCase();
            var payLabel = '';
            if (payName.indexOf('alipay') !== -1) payLabel = 'Alipay';
            else if (payName.indexOf('wechat') !== -1) payLabel = 'WeChat Pay';
            else if (payName.indexOf('hsbc') !== -1) payLabel = 'HSBC';
            gC(payLabelRow, 4).value = payLabel;

            var bankRow = totalRow + 5;
            gC(bankRow, 1).value = (data.payment_info && data.payment_info.text || '').trim();

            var mfrRow = totalRow + 10;
            gC(mfrRow, 1).value = data.manufacturer_info || '';

            // QR Code image
            var qrData = data.payment_info && data.payment_info.image_data;
            if (qrData) {
                var qrBase64 = qrData.split(',')[1] || qrData;
                var qrImgId = wb.addImage({ base64: qrBase64, extension: 'png' });
                var qrRow = totalRow + 3;
                ws.addImage(qrImgId, {
                    tl: { col: 3.2, row: qrRow },
                    ext: { width: 230, height: 320 },
                    editAs: 'absolute'
                });
            }

            return wb.xlsx.writeBuffer();
        })
        .then(function(buffer) {
            var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            window._lastInvoiceBlob = blob;
            window._lastInvoiceNo = data.invoice_no;
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = 'Invoice_' + data.invoice_no + '.xlsx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            var dlBtn = document.getElementById('is-download-btn');
            if (dlBtn) dlBtn.style.display = 'block';
            sT('发票生成成功！', 'success');
        })
        .catch(function(e) {
            sT('生成失败: ' + e.message, 'error');
            console.error(e);
        });

    }); // End Promise.all(imagePromises)
}

// ===== Standard Quote Excel Generator (from scratch) =====
function isGenerateSQ() {
    var items = Object.values(_sqItems||{}).filter(function(i){return i.model_no&&i.model_no.trim();});
    if(!items.length){sT("请至少填写一个产品型号","error");return;}
    var data = {
        invoice_no: "SQ-"+new Date().toISOString().slice(0,10).replace(/-/g,""),
        date: (document.getElementById("sq-form-date")||{}).value||"",
        validity: (document.getElementById("sq-form-validity")||{}).value||"",
        title: (document.getElementById("sq-form-title")||{}).value||"QUOTATION",
        incoterm: (document.getElementById("sq-form-incoterm")||{}).value||"FOB Shenzhen",
        company: "",
        company_contact: (document.getElementById("sq-form-contact")||{}).value||"",
        items: items.map(function(i){
            var tiers = i.tiers || [];
            return {
                model_no:i.model_no.trim(),
                product_name:i.product_name||"",
                description:i.description||"",
                image_data:i.image_data||"",
                packaging:i.packaging||"",
                tiers: tiers.map(function(t){ return {qty:t.qty||"", price:t.price||""}; })
            };
        })
    };
    isGenerateSQExcel(data);
}
function isGenerateSQExcel(data) {
    var ExcelJS = window.ExcelJS; if (!ExcelJS) { alert("ExcelJS not loaded"); return; }
    var items = data.items; var N = items.length;
    var nf = "\"US$\"#,##0.00";
    var company = data.company || "SHENZHEN EFAST TECHNOLOGY CO., LTD.";
    var wb = new ExcelJS.Workbook();
    var ws = wb.addWorksheet("Standard Quotation", {views:[{showGridLines:false}]});
    ws.getColumn(1).width = 26.78; ws.getColumn(2).width = 28.44;
    ws.getColumn(3).width = 52; ws.getColumn(4).width = 12;
    ws.getColumn(5).width = 14; ws.getColumn(6).width = 25;
    var darkBlue = "FF1F3864", lightGray = "FFF2F2F2", borderGray = "FFD9D9D9";
    var termsBg = "FFF8F9FA";
    var fontName = "Microsoft YaHei";
    function cell(r,c){ return ws.getRow(r).getCell(c); }
    function setFont(ce, opts){ ce.font = Object.assign({name:fontName,family:2}, opts); }
    function setFill(ce, color){ ce.fill = {type:"pattern",pattern:"solid",fgColor:{argb:color}}; }
    // R1 empty
    ws.getRow(1).height = 15;
    // R2: Company name + QUOTATION
    ws.getRow(2).height = 25.05;
    var c2a = cell(2,1); c2a.value = company;
    setFont(c2a, {bold:true, size:14, color:{argb:darkBlue}});
    c2a.alignment = {horizontal:"left", vertical:"middle"};
    var c2f = cell(2,6); c2f.value = "QUOTATION";
    setFont(c2f, {bold:true, size:16, color:{argb:"FF000000"}});
    c2f.alignment = {horizontal:"right", vertical:"middle"};
    // R3: Contact + Tagline
    ws.getRow(3).height = 42;
    ws.mergeCells("A3:C3"); ws.mergeCells("D3:F3");
    cell(3,1).value = data.company_contact || "";
    setFont(cell(3,1), {size:9, color:{argb:"FF595959"}});
    cell(3,1).alignment = {horizontal:"left", vertical:"middle", wrapText:true};
    cell(3,4).value = "Direct Factory. CE//RoHS/REACH Certified";
    setFont(cell(3,4), {size:9, color:{argb:"FF595959"}});
    cell(3,4).alignment = {horizontal:"right", vertical:"middle", wrapText:true};
    // R4-R5 empty
    ws.getRow(4).height = 4.05;
    ws.getRow(5).height = 15;
    // R6-R8: Left gray area + Right Date/Validity/Incoterm
    ws.mergeCells("A6:C8");
    for (var rr = 6; rr <= 8; rr++) {
        ws.getRow(rr).height = 19.95;
        for (var cc = 1; cc <= 3; cc++) {
            var ce = cell(rr,cc);
            setFill(ce, lightGray);
            setFont(ce, {bold:true, size:14, color:{argb:"FF2F2F2F"}});
            ce.alignment = {horizontal:"center", vertical:"middle", wrapText:true};
            if (cc === 3) ce.border = {right:{style:"thin",color:{argb:borderGray}}};
        }
    }
    cell(6,1).value = data.title || "";
    ws.mergeCells("E6:F6"); ws.mergeCells("E7:F7"); ws.mergeCells("E8:F8");
    cell(6,4).value = "Date:"; setFont(cell(6,4), {bold:true, size:9});
    cell(7,4).value = "Validity:"; setFont(cell(7,4), {bold:true, size:9});
    cell(8,4).value = "Incoterm:"; setFont(cell(8,4), {bold:true, size:9});
    if (data.date) cell(6,5).value = data.date;
    if (data.validity) cell(7,5).value = data.validity;
    if (data.incoterm) cell(8,5).value = data.incoterm;
    // R9 empty
    ws.getRow(9).height = 15;
    // R10: Headers
    ws.getRow(10).height = 25.05;
    var headers = ["Model No.", "Photo", "Product Description & Specs", "Quantity", "Unit Price", "Packaging Details"];
    for (var ci = 0; ci < 6; ci++) {
        var hc = cell(10, ci+1);
        hc.value = headers[ci];
        setFill(hc, darkBlue);
        setFont(hc, {bold:true, size:10, color:{argb:"FFFFFFFF"}});
        hc.alignment = {horizontal:"center", vertical:"middle"};
    }
    // Product rows: 4 rows per product
    var ROWS_PER = 4;
    var termsStart = 11 + N * ROWS_PER + 1;
    for (var pi = 0; pi < N; pi++) {
        var baseRow = 11 + pi * ROWS_PER;
        var item = items[pi];
        var tiers = item.tiers || [];
        // Merge A, B, C, F columns
        ws.mergeCells("A"+baseRow+":A"+(baseRow+ROWS_PER-1));
        ws.mergeCells("B"+baseRow+":B"+(baseRow+ROWS_PER-1));
        ws.mergeCells("C"+baseRow+":C"+(baseRow+ROWS_PER-1));
        ws.mergeCells("F"+baseRow+":F"+(baseRow+ROWS_PER-1));
        // Style all cells
        for (var rr = baseRow; rr < baseRow + ROWS_PER; rr++) {
            ws.getRow(rr).height = 39;
            for (var cc = 1; cc <= 6; cc++) {
                var pc = cell(rr, cc);
                setFill(pc, lightGray);
                pc.border = {top:{style:"thin",color:{argb:borderGray}}, bottom:{style:"thin",color:{argb:borderGray}}, left:{style:"thin",color:{argb:borderGray}}, right:{style:"thin",color:{argb:borderGray}}};
                setFont(pc, {size:9, color:{argb:"FF2F2F2F"}});
                if (cc === 1) pc.alignment = {horizontal:"center", vertical:"middle", wrapText:true};
                else if (cc === 2) pc.alignment = {horizontal:"center", vertical:"middle"};
                else if (cc === 3) pc.alignment = {horizontal:"left", vertical:"middle", wrapText:true};
                else if (cc === 6) pc.alignment = {horizontal:"left", vertical:"middle", wrapText:true};
                else pc.alignment = {horizontal:"center", vertical:"middle"};
            }
        }
        // Fill values
        cell(baseRow,1).value = (item.model_no + " " + (item.product_name||"")).trim();
        cell(baseRow,3).value = item.description || "";
        cell(baseRow,6).value = item.packaging || "";
        // D, E: tier data (up to 4)
        for (var t = 0; t < 4; t++) {
            var tr = baseRow + t;
            if (t < tiers.length) {
                cell(tr,4).value = tiers[t].qty || "";
                cell(tr,5).value = tiers[t].price || "";
                if (typeof tiers[t].price === "number" || !isNaN(parseFloat(tiers[t].price))) {
                    cell(tr,5).numFmt = nf;
                }
            }
        }
    }
    // Empty separator row
    var sepRow = 11 + N * ROWS_PER;
    ws.getRow(sepRow).height = 15;
    // Terms & Conditions
    var terms = [
        {label:"TERMS & CONDITIONS:", bold:true, size:10, color:darkBlue},
        {label:"1. Payment Terms:", value:"30% advance deposit by T/T, 70% remaining balance paid before shipment. T/T, L/C, PayPal, Western Union accepted.", bold:true, size:9, color:"FF404040"},
        {label:"2. Lead Time:", value:"3 day for samples, 15-30 days for bulk order depending on quantity.", bold:true, size:9, color:"FF404040"},
        {label:"3. Price Terms:", value:"Prices quoted are based on FOB Shenzhen. For CIF/C&F terms, please contact us for a tailored quote.", bold:true, size:9, color:"FF404040"},
        {label:"4. Quality Warranty:", value:"12 months manufacturer warranty. 100% fully tested before shipment. Free replacement for any quality issue.", bold:true, size:9, color:"FF404040"},
        {label:"5. Certificates:", value:"All products CE, FCC, RoHS certified. Certificates can be provided upon request.", bold:true, size:9, color:"FF404040"},
        {label:"6. Logo Customization:", value:"Laser engraving or silk-screen printing available. MOQ applies. Please inquiry for details.", bold:true, size:9, color:"FF404040"}
    ];
    for (var ti = 0; ti < terms.length; ti++) {
        var tr = termsStart + ti;
        ws.getRow(tr).height = 19.95;
        var t = terms[ti];
        if (ti === 0) ws.mergeCells("A"+tr+":F"+tr);
        else ws.mergeCells("B"+tr+":F"+tr);
        var tc = cell(tr, 1);
        tc.value = t.label;
        setFill(tc, termsBg);
        setFont(tc, {bold:true, size:t.size, color:{argb:t.color}});
        tc.alignment = {horizontal:"left", vertical:"middle", indent:1};
        if (ti > 0) {
            var tv = cell(tr, 2);
            tv.value = t.value;
            setFill(tv, termsBg);
            setFont(tv, {size:9, color:{argb:"FF2F2F2F"}});
            tv.alignment = {horizontal:"left", vertical:"middle"};
        }
    }
    // Product images (in col B)
    var imgPromises = [];
    for (var pi2 = 0; pi2 < N; pi2++) {
        (function(pitem, rowIdx){
            var col = 1;
            if (pitem.image_data && pitem.image_data.indexOf("data:") === 0) {
                var imgId = wb.addImage({base64: pitem.image_data.split(",")[1], extension: "png"});
                var pr = 11 + rowIdx * ROWS_PER;
                ws.addImage(imgId, {tl:{col:col, row:pr-1}, ext:{width:200, height:200}});
            }
        })(items[pi2], pi2);
    }
    // Generate & download
    wb.xlsx.writeBuffer().then(function(buf) {
        var blob = new Blob([buf], {type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = "Standard_Quote_SQ-" + data.invoice_no + ".xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    });
}
// ===== Customize Quote Excel Generator (from scratch) =====
function isGenerateCQ() {
    var items = Object.values(_cqItems||{}).filter(function(i){return i.model_no&&i.model_no.trim();});
    if(!items.length){sT("请至少填写一个产品型号","error");return;}
    var data = {
        invoice_no: "CQ-"+new Date().toISOString().slice(0,10).replace(/-/g,""),
        date: (document.getElementById("cq-form-date")||{}).value||"",
        validity: (document.getElementById("cq-form-validity")||{}).value||"",
        title: (document.getElementById("cq-form-title")||{}).value||"QUOTATION",
        incoterm: (document.getElementById("cq-form-incoterm")||{}).value||"FOB Shenzhen",
        company: "",
        company_contact: (document.getElementById("cq-form-contact")||{}).value||"",
        items: items.map(function(i){return{model_no:i.model_no.trim(),product_name:i.product_name||"",description:i.description||"",qty:i.qty||1,unit_price:i.unit_price||0,image_data:i.image_data||"",lead_time:i.lead_time||"",packaging:i.packaging||""};})
    };
    isGenerateCQExcel(data);
}
function isGenerateCQExcel(data) {
    var ExcelJS = window.ExcelJS; if (!ExcelJS) { alert("ExcelJS not loaded"); return; }
    var items = data.items; var N = items.length;
    var nf = "\"US$\"#,##0.00";
    var company = data.company || "SHENZHEN EFAST TECHNOLOGY CO., LTD.";
    var wb = new ExcelJS.Workbook();
    var ws = wb.addWorksheet("Customize Quotation", {views:[{showGridLines:false}]});
    ws.getColumn(1).width = 26.78; ws.getColumn(2).width = 28.44;
    ws.getColumn(3).width = 52; ws.getColumn(4).width = 12;
    ws.getColumn(5).width = 14; ws.getColumn(6).width = 14;
    ws.getColumn(7).width = 25;
    var darkBlue = "FF1F3864", lightGray = "FFF2F2F2", borderGray = "FFD9D9D9";
    var termsBg = "FFF8F9FA";
    var fontName = "Microsoft YaHei";
    function cell(r,c){ return ws.getRow(r).getCell(c); }
    function setFont(ce, opts){ ce.font = Object.assign({name:fontName,family:2}, opts); }
    function setFill(ce, color){ ce.fill = {type:"pattern",pattern:"solid",fgColor:{argb:color}}; }
    ws.getRow(1).height = 15;
    ws.getRow(2).height = 25.05;
    var c2a = cell(2,1); c2a.value = company;
    setFont(c2a, {bold:true, size:14, color:{argb:darkBlue}});
    c2a.alignment = {horizontal:"left", vertical:"middle"};
    var c2g = cell(2,7); c2g.value = "QUOTATION";
    setFont(c2g, {bold:true, size:16, color:{argb:"FF000000"}});
    c2g.alignment = {horizontal:"right", vertical:"middle"};
    ws.getRow(3).height = 42;
    ws.mergeCells("A3:C3"); ws.mergeCells("D3:G3");
    cell(3,1).value = data.company_contact || "";
    setFont(cell(3,1), {size:9, color:{argb:"FF595959"}});
    cell(3,1).alignment = {horizontal:"left", vertical:"middle", wrapText:true};
    cell(3,4).value = "Direct Factory. CE//RoHS/REACH Certified";
    setFont(cell(3,4), {size:9, color:{argb:"FF595959"}});
    cell(3,4).alignment = {horizontal:"right", vertical:"middle", wrapText:true};
    ws.getRow(4).height = 4.05; ws.getRow(5).height = 15;
    ws.mergeCells("A6:C8");
    for (var rr = 6; rr <= 8; rr++) {
        ws.getRow(rr).height = 19.95;
        for (var cc = 1; cc <= 3; cc++) {
            var ce = cell(rr,cc);
            setFill(ce, lightGray);
            setFont(ce, {bold:true, size:14, color:{argb:"FF2F2F2F"}});
            ce.alignment = {horizontal:"center", vertical:"middle", wrapText:true};
            if (cc === 3) ce.border = {right:{style:"thin",color:{argb:borderGray}}};
        }
    }
    cell(6,1).value = data.title || "";
    ws.mergeCells("E6:G6"); ws.mergeCells("E7:G7"); ws.mergeCells("E8:G8");
    cell(6,4).value = "Date:"; setFont(cell(6,4), {bold:true, size:9});
    cell(7,4).value = "Validity:"; setFont(cell(7,4), {bold:true, size:9});
    cell(8,4).value = "Incoterm:"; setFont(cell(8,4), {bold:true, size:9});
    if (data.date) cell(6,5).value = data.date;
    if (data.validity) cell(7,5).value = data.validity;
    if (data.incoterm) cell(8,5).value = data.incoterm;
    ws.getRow(9).height = 15;
    ws.getRow(10).height = 25.05;
    var headers = ["Model No.", "Photo", "Product Description & Customization Details", "Quantity", "Unit Price", "Lead Time", "Packaging Details"];
    for (var ci = 0; ci < 7; ci++) {
        var hc = cell(10, ci+1);
        hc.value = headers[ci];
        setFill(hc, darkBlue);
        setFont(hc, {bold:true, size:10, color:{argb:"FFFFFFFF"}});
        hc.alignment = {horizontal:"center", vertical:"middle"};
    }
    // Product rows: 4 rows per product, all merged
    var ROWS_PER = 4;
    var termsStart = 11 + N * ROWS_PER + 1;
    for (var pi = 0; pi < N; pi++) {
        var baseRow = 11 + pi * ROWS_PER;
        var item = items[pi];
        // Merge all columns
        ws.mergeCells("A"+baseRow+":A"+(baseRow+ROWS_PER-1));
        ws.mergeCells("B"+baseRow+":B"+(baseRow+ROWS_PER-1));
        ws.mergeCells("C"+baseRow+":C"+(baseRow+ROWS_PER-1));
        ws.mergeCells("D"+baseRow+":D"+(baseRow+ROWS_PER-1));
        ws.mergeCells("E"+baseRow+":E"+(baseRow+ROWS_PER-1));
        ws.mergeCells("F"+baseRow+":F"+(baseRow+ROWS_PER-1));
        ws.mergeCells("G"+baseRow+":G"+(baseRow+ROWS_PER-1));
        for (var rr = baseRow; rr < baseRow + ROWS_PER; rr++) {
            ws.getRow(rr).height = 39;
            for (var cc = 1; cc <= 7; cc++) {
                var pc = cell(rr, cc);
                setFill(pc, lightGray);
                pc.border = {top:{style:"thin",color:{argb:borderGray}}, bottom:{style:"thin",color:{argb:borderGray}}, left:{style:"thin",color:{argb:borderGray}}, right:{style:"thin",color:{argb:borderGray}}};
                setFont(pc, {size:9, color:{argb:"FF2F2F2F"}});
                if (cc === 1) pc.alignment = {horizontal:"center", vertical:"middle", wrapText:true};
                else if (cc === 2) pc.alignment = {horizontal:"center", vertical:"middle"};
                else if (cc === 3) pc.alignment = {horizontal:"left", vertical:"middle", wrapText:true};
                else if (cc === 7) pc.alignment = {horizontal:"left", vertical:"middle", wrapText:true};
                else pc.alignment = {horizontal:"center", vertical:"middle"};
            }
        }
        cell(baseRow,1).value = (item.model_no + " " + (item.product_name||"")).trim();
        cell(baseRow,3).value = item.description || "";
        cell(baseRow,4).value = item.qty || "";
        cell(baseRow,5).value = item.unit_price;
        if (typeof item.unit_price === "number") cell(baseRow,5).numFmt = nf;
        cell(baseRow,6).value = item.lead_time || "";
        cell(baseRow,7).value = item.packaging || "";
    }
    ws.getRow(11 + N * ROWS_PER).height = 15;
    // Terms & Conditions
    var terms = [
        {label:"TERMS & CONDITIONS:", bold:true, size:10, color:darkBlue},
        {label:"1. Payment Terms:", value:"30% advance deposit by T/T, 70% remaining balance paid before shipment. T/T, L/C, PayPal, Western Union accepted.", bold:true, size:9, color:"FF404040"},
        {label:"2. Lead Time:", value:"3 day for samples, 15-30 days for bulk order depending on quantity.", bold:true, size:9, color:"FF404040"},
        {label:"3. Price Terms:", value:"Prices quoted are based on FOB Shenzhen. For CIF/C&F terms, please contact us for a tailored quote.", bold:true, size:9, color:"FF404040"},
        {label:"4. Quality Warranty:", value:"12 months manufacturer warranty. 100% fully tested before shipment. Free replacement for any quality issue.", bold:true, size:9, color:"FF404040"},
        {label:"5. Certificates:", value:"All products CE, FCC, RoHS certified. Certificates can be provided upon request.", bold:true, size:9, color:"FF404040"},
        {label:"6. Logo Customization:", value:"Laser engraving or silk-screen printing available. MOQ applies. Please inquiry for details.", bold:true, size:9, color:"FF404040"}
    ];
    for (var ti = 0; ti < terms.length; ti++) {
        var tr = termsStart + ti;
        ws.getRow(tr).height = 19.95;
        var t = terms[ti];
        if (ti === 0) ws.mergeCells("A"+tr+":G"+tr);
        else ws.mergeCells("B"+tr+":G"+tr);
        var tc = cell(tr, 1);
        tc.value = t.label;
        setFill(tc, termsBg);
        setFont(tc, {bold:true, size:t.size, color:{argb:t.color}});
        tc.alignment = {horizontal:"left", vertical:"middle", indent:1};
        if (ti > 0) {
            var tv = cell(tr, 2);
            tv.value = t.value;
            setFill(tv, termsBg);
            setFont(tv, {size:9, color:{argb:"FF2F2F2F"}});
            tv.alignment = {horizontal:"left", vertical:"middle"};
        }
    }
    // Images: 200x200
    for (var pi2 = 0; pi2 < N; pi2++) {
        (function(pitem, rowIdx){
            if (pitem.image_data && pitem.image_data.indexOf("data:") === 0) {
                var imgId = wb.addImage({base64: pitem.image_data.split(",")[1], extension: "png"});
                var pr = 11 + rowIdx * ROWS_PER;
                ws.addImage(imgId, {tl:{col:1, row:pr-1}, ext:{width:200, height:200}});
            }
        })(items[pi2], pi2);
    }
    // Download
    wb.xlsx.writeBuffer().then(function(buf) {
        var blob = new Blob([buf], {type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = "Customize_Quote_CQ-" + data.invoice_no + ".xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    });
}
// ===== 系统设置 - 公司抬头管理 =====
function refreshHeaderSelect() {
    var sel = document.getElementById('is-hdr-select');
    if (!sel) return;
    var currentValue = sel.value;
    sel.innerHTML = '<option value="">请选择抬头</option>';
    ih().forEach(function(h, idx) {
        sel.innerHTML += '<option value="' + idx + '">' + escapeHtml(h.name) + '</option>';
    });
    sel.value = currentValue;
}

function loadSelectedHeader() {
    var sel = document.getElementById('is-hdr-select');
    if (!sel || sel.value === '') {
        document.getElementById('is-hdr-name').value = '';
        document.getElementById('is-hdr-company').value = '';
        document.getElementById('is-hdr-contact').value = '';
        document.getElementById('is-hdr-manufacturer').value = '';
        document.getElementById('is-hdr-shipper').value = '';
        document.getElementById('is-hdr-ship-phone').value = '';
        document.getElementById('is-hdr-ship-address').value = '';
        return;
    }
    var idx = parseInt(sel.value);
    var headers = ih();
    if (headers[idx]) {
        var h = headers[idx];
        document.getElementById('is-hdr-name').value = h.name || '';
        document.getElementById('is-hdr-company').value = h.company_name || '';
        document.getElementById('is-hdr-contact').value = h.contact || '';
        document.getElementById('is-hdr-manufacturer').value = h.manufacturer_info || '';
        document.getElementById('is-hdr-shipper').value = h.shipper || '';
        document.getElementById('is-hdr-ship-phone').value = h.ship_phone || '';
        document.getElementById('is-hdr-ship-address').value = h.ship_address || '';
    }
}

function addNewHeader() {
    document.getElementById('is-hdr-select').value = '';
    document.getElementById('is-hdr-name').value = '';
    document.getElementById('is-hdr-company').value = '';
    document.getElementById('is-hdr-contact').value = '';
    document.getElementById('is-hdr-manufacturer').value = '';
    document.getElementById('is-hdr-name').focus();
}

function deleteIsHeader() {
    var sel = document.getElementById('is-hdr-select');
    if (!sel || sel.value === '') {
        sT('请先选择要删除的抬头', 'error');
        return;
    }
    if (!confirm('确定要删除该抬头吗？')) return;
    var idx = parseInt(sel.value);
    var headers = ih();
    headers.splice(idx, 1);
    isave(IK.headers, headers);
    refreshHeaderSelect();
    refreshAllIsLists();
    refreshIsDropdowns();
    addNewHeader();
    sT('删除成功', 'success');
}

// ===== 系统设置 - 收款信息管理 =====
function refreshPaymentSelect() {
    var sel = document.getElementById('is-pay-select');
    if (!sel) return;
    var currentValue = sel.value;
    sel.innerHTML = '<option value="">请选择账户</option>';
    ipa().forEach(function(p, idx) {
        sel.innerHTML += '<option value="' + idx + '">' + escapeHtml(p.name) + '</option>';
    });
    sel.value = currentValue;
}

function loadSelectedPayment() {
    var sel = document.getElementById('is-pay-select');
    if (!sel || sel.value === '') {
        document.getElementById('is-pay-name').value = '';
        document.getElementById('is-pay-text').value = '';
        document.getElementById('is-pay-img-preview').innerHTML = '<i class="fa-solid fa-image" style="font-size:2rem;color:var(--text-muted);"></i><span style="color:var(--text-muted);font-size:0.85rem;">暂无图片</span>';
        return;
    }
    var idx = parseInt(sel.value);
    var payments = ipa();
    if (payments[idx]) {
        var p = payments[idx];
        document.getElementById('is-pay-name').value = p.name || '';
        document.getElementById('is-pay-text').value = p.text || '';
        var preview = document.getElementById('is-pay-img-preview');
        if (p.image_path) {
            preview.innerHTML = '<img src="/api/payment-image/' + p.image_path + '" alt="收款码">';
        } else {
            preview.innerHTML = '<i class="fa-solid fa-image" style="font-size:2rem;color:var(--text-muted);"></i><span style="color:var(--text-muted);font-size:0.85rem;">暂无图片</span>';
        }
    }
}

function addNewPayment() {
    document.getElementById('is-pay-select').value = '';
    document.getElementById('is-pay-name').value = '';
    document.getElementById('is-pay-text').value = '';
    document.getElementById('is-pay-img-preview').innerHTML = '<i class="fa-solid fa-image" style="font-size:2rem;color:var(--text-muted);"></i><span style="color:var(--text-muted);font-size:0.85rem;">暂无图片</span>';
    document.getElementById('is-pay-name').focus();
}

function deleteIsPayment() {
    var sel = document.getElementById('is-pay-select');
    if (!sel || sel.value === '') {
        sT('请先选择要删除的账户', 'error');
        return;
    }
    if (!confirm('确定要删除该账户吗？')) return;
    var idx = parseInt(sel.value);
    var payments = ipa();
    payments.splice(idx, 1);
    isave(IK.payments, payments);
    refreshPaymentSelect();
    refreshAllIsLists();
    refreshIsDropdowns();
    addNewPayment();
    sT('删除成功', 'success');
}

function previewPaymentImg(input) {
    var preview = document.getElementById('is-pay-img-preview');
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function(e) {
            preview.innerHTML = '<img src="' + e.target.result + '" alt="收款码">';
        };
        reader.readAsDataURL(input.files[0]);
    }
}

// ===== 全局汇率函数 =====
function getExchangeRate() {
    try {
        var stored = localStorage.getItem('efast_exchange_rate');
        if (stored) {
            var parsed = JSON.parse(stored);
            return parsed.exchange_rate || 7.1;
        }
    } catch(e) {}
    return 7.1;
}

// ===== 系统设置 - 考核汇率保存 =====
function saveIsRate() { var v = parseFloat(document.getElementById('is-rate-usd-cny').value); if (isNaN(v) || v <= 0) { sT('请输入有效的汇率', 'error'); return; } isave(IK.exchangeRate, { exchange_rate: v });syncSettingsToServer(); sT('汇率已更新', 'success'); updateTopBarRate(); if (typeof updateAllProductRateDisplays === 'function') updateAllProductRateDisplays(); }

// ===== 顶栏汇率显示 =====
function updateTopBarRate() {
    var el = document.getElementById('topbar-rate-value');
    if (el) {
        el.textContent = getExchangeRate().toFixed(4);
    }
}

// ===== 初始化系统设置 (含服务器同步) =====
function initSystemSettings() {
    var doRefresh = function() {
        refreshHeaderSelect();
        refreshPaymentSelect();
        var rate = ier();
        var rateInput = document.getElementById('is-rate-usd-cny');
        if (rateInput && rate) { rateInput.value = rate.exchange_rate || 7.1; }
        updateTopBarRate();
    };

    fetch('/api/settings', { headers: { 'Authorization': 'Bearer ' + (typeof Auth !== 'undefined' && Auth.getToken ? Auth.getToken() : '') } })
        .then(function(r) { if (r.ok) return r.json(); return null; })
        .catch(function() { return null; })
        .then(function(settings) {
            if (settings) {
                var restoreMap = {
                    'headers': IK.headers,
                    'payments': IK.payments,
                    'exchangeRate': IK.exchangeRate,
                    'termsPayment': IK.termsPayment,
                    'termsShipping': IK.termsShipping,
                    'termsMethods': IK.termsMethods,
                    'termsCurrencies': IK.termsCurrencies
                };
                Object.keys(restoreMap).forEach(function(key) {
                    if (settings[key]) {
                        isave(restoreMap[key], settings[key]);
                    }
                });
                if (settings.inquiries && !localStorage.getItem('efast_real_inquiries')) {
                    localStorage.setItem('efast_real_inquiries', JSON.stringify(settings.inquiries));
                }
                console.log('[Settings] Synced from server');
            }
            doRefresh();
        });
}

window.openInvoiceBuilder = openInvoiceBuilder;


// window bridges for template onclick handlers
window.toggleSettingsSection = toggleSettingsSection;
window.switchIsTermsTab = switchIsTermsTab;
window.saveIsHeader = saveIsHeader;
window.deleteIsHeader = deleteIsHeader;
window.addNewPayment = addNewPayment;
window.saveIsPayment = saveIsPayment;
window.deleteIsPayment = deleteIsPayment;
window.saveIsRate = saveIsRate;
window.addIsTerm = addIsTerm;

window.addIsItem = addIsItem;
window.isDownloadLast = isDownloadLast;
window.isGenerateSQ = isGenerateSQ;
window.isGenerateCQ = isGenerateCQ;
window.addSqItem = addSqItem;
window.removeSqItem = removeSqItem;
window.refreshSqItemOpts = refreshSqItemOpts;
window.onSqItemModelInput = onSqItemModelInput;
window.onSqItemModelChange = onSqItemModelChange;
window.onSqItemImg = onSqItemImg;
window.onSqHeaderSelect = onSqHeaderSelect;
window.addCqItem = addCqItem;
window.removeCqItem = removeCqItem;
window.refreshCqItemOpts = refreshCqItemOpts;
window.onCqItemModelInput = onCqItemModelInput;
window.onCqItemModelChange = onCqItemModelChange;
window.onCqItemImg = onCqItemImg;
window.onCqHeaderSelect = onCqHeaderSelect;
window.isGenerate = isGenerate;
window.removeIsItem = removeIsItem;
window.switchInvoiceTab = switchInvoiceTab;

// Global bridges for inline onclick handlers (generated by renderIsList)
window.ih = ih;
window.isave = isave;
window.IK = IK;
window.sT = sT;
window.icu = icu;
window.ipr = ipr;
window.itp = itp;
window.its = its;
window.itm = itm;
window.itc = itc;
window.ib = ib;
window.iload = iload;
window.iget = iget;
window.DIF = DIF;
window.isV = isV;
window.sB64 = sB64;
window.sImg = sImg;
window.gImg = gImg;
window.syncSettingsToServer = syncSettingsToServer;
window.onIsCurrencyChange = onIsCurrencyChange;
window.onIsCustomerSelect = onIsCustomerSelect;
window.onIsHeaderSelect = onIsHeaderSelect;
window.onIsItemImg = onIsItemImg;
window.onIsItemModelChange = onIsItemModelChange;
window.onIsItemModelInput = onIsItemModelInput;
window.onIsItemQty = onIsItemQty;
window.onIsCustnameInput = onIsCustnameInput;
window.onIsPaymentSelect = onIsPaymentSelect;
window.onIsPayTermChange = onIsPayTermChange;
window.onIsShipMethodChange = onIsShipMethodChange;
window.onIsShipTermChange = onIsShipTermChange;
window.isImportCRM = isImportCRM;
window.isGenerateOrder = isGenerateOrder;
window.updateIsItemSubtotal = updateIsItemSubtotal;

window.loadSelectedHeader = loadSelectedHeader;
window.loadSelectedPayment = loadSelectedPayment;
window.refreshAllIsLists = refreshAllIsLists;


// ===== AI API 配置 =====

var _rebuildMode = null;



function _pollUntilDone() {
    var count = 0, maxCount = 80;
    var lastProdCount = -1;
    var productTotal = 200;
    // Fetch total product count
    Auth.apiFetch('/api/products').then(function(r) {
        if (r && r.products) productTotal = r.products.length;
    }).catch(function(){});
    
    var timer = setInterval(async function() {
        count++;
        try { var d = await Auth.apiFetch('/api/knowledge-base/index-status'); } catch(e) { d = null; }
        var statusEl = document.getElementById(_rebuildMode === 'kb' ? 'kb-index-status' : 'product-index-status');
        if (!statusEl) { clearInterval(timer); _resetRebuildBtns(); return; }
        
        if (_rebuildMode === 'kb') {
            if (d && d.indexed && !d.stale) {
                statusEl.innerHTML = '📝 <b>知识库</b>: ' + d.fileCount + ' 文件, ' + d.chunkCount + ' 向量块 (上次: ' + new Date(d.indexedAt).toLocaleString('zh-CN') + ')';
                clearInterval(timer); _resetRebuildBtns(); return;
            }
            statusEl.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> <b>知识库: 重建中...</b>';
        } else {
            var built = d && d.productChunkCount ? d.productChunkCount : 0;
            var remaining = productTotal - built;
            // Estimate: ~2 seconds per product, each poll is 3s apart, ~1.5 products per poll
            var estMin = remaining > 0 ? Math.ceil(remaining * 2 / 60) : 0;
            
            // Check if done: count reached total OR count stable for 3 polls
            if (built >= productTotal) {
                statusEl.innerHTML = '📦 <b>产品知识库</b>: ' + built + ' 个产品向量';
                clearInterval(timer); _resetRebuildBtns(); return;
            }
            lastProdCount = built;
            
            var progressMsg = '<i class="fa-solid fa-spinner fa-spin"></i> <b>产品索引重建中...</b>';
            progressMsg += '<br><span style="font-size:12px;">共计 ' + productTotal + ' 个产品向量化，已重建 ' + built + ' 个';
            if (estMin > 0) progressMsg += '，剩余约 ' + estMin + ' 分钟';
            progressMsg += '</span>';
            statusEl.innerHTML = progressMsg;
        }
        if (count >= maxCount) { clearInterval(timer); _resetRebuildBtns(); }
    }, 3000);
}

function _resetRebuildBtns() {
    _rebuildMode = null;
    var kbBtn = document.getElementById('btn-rebuild-kb');
    var prodBtn = document.getElementById('btn-rebuild-product');
    if (kbBtn) { kbBtn.disabled = false; kbBtn.textContent = '🔄 重建知识库'; }
    if (prodBtn) { prodBtn.disabled = false; prodBtn.textContent = '🔄 重建产品索引'; }
}

async function loadKBIndexStatus() {
    if (_rebuildMode) return;
    try {
        var d = await Auth.apiFetch('/api/knowledge-base/index-status');
        
        var kbEl = document.getElementById('kb-index-status');
        if (kbEl) {
            var h = '';
            if (d.indexed) {
                h += '📝 <b>知识库</b>: ' + d.fileCount + ' 文件, ' + d.chunkCount + ' 向量块 ';
                if (d.indexedAt) h += '(上次: ' + new Date(d.indexedAt).toLocaleString('zh-CN') + ')';
                if (d.stale) h += ' <span style="color:#d97706;">⚠️ 有过期文件</span>';
            } else {
                h += '📝 <b>知识库</b>: 未建立';
            }
            kbEl.innerHTML = h;
        }
        
        var prodEl = document.getElementById('product-index-status');
        if (prodEl) {
            var h2 = '';
            if (d.hasProductIndex && d.productChunkCount > 0) {
                h2 += '📦 <b>产品知识库</b>: ' + d.productChunkCount + ' 个产品向量 (上次: ' + new Date(d.productIndexedAt).toLocaleString('zh-CN') + ')';
            } else {
                h2 += '📦 <b>产品知识库</b>: 未建立';
            }
            prodEl.innerHTML = h2;
        }
    } catch(e) {
        var kbEl2 = document.getElementById('kb-index-status');
        if (kbEl2) kbEl2.innerHTML = '⚠️ 无法获取: ' + e.message;
    }
}

// ===== Packing List =====
var _plItems = [];
var _plCounter = 0;
var _plGroups = [];
var _plLastBlob = null;

function isGeneratePL() {
    var headerSel = isV('is-form-header');
    var hdrData = null;
    if (headerSel) { var hdrs = window.ih(); hdrData = hdrs.find(function(h) { return h.name === headerSel; }); }
    var shipper = hdrData ? (hdrData.shipper || '') : '';
    var shipPhone = hdrData ? (hdrData.ship_phone || '') : '';
    var shipAddress = hdrData ? (hdrData.ship_address || '') : '';
    var contact = isV('is-form-contact');
    var company = isV('is-form-company');
    var headerSel = isV('is-form-header');
    var custName = isV('is-form-custname');
    var custTel = isV('is-form-custtel');
    var custAddr = isV('is-form-custaddr');
    var custSel = isV('is-form-customer');
    var shipMethod = typeof isGetShipMethod === 'function' ? isGetShipMethod() : '';
    var piItems = window._isItems || {};
    
    switchInvoiceTab('packing-list');
    _plItems = []; _plCounter = 0; _plGroups = [];
    setTimeout(function() {
        var hdrEl = document.getElementById('pl-form-header');
        if (hdrEl) {
            var headers = window.ih();
            hdrEl.innerHTML = '<option value="">-- 手动输入 --</option>';
            headers.forEach(function(h) {
                hdrEl.innerHTML += '<option value="' + h.name + '"' + (h.name === headerSel ? ' selected' : '') + '>' + h.name + '</option>';
            });
        }
        document.getElementById('pl-form-company') && (document.getElementById('pl-form-company').value = company);
        document.getElementById('pl-form-shipper') && (document.getElementById('pl-form-shipper').value = shipper);
        document.getElementById('pl-form-ship-phone') && (document.getElementById('pl-form-ship-phone').value = shipPhone);
        document.getElementById('pl-form-ship-address') && (document.getElementById('pl-form-ship-address').value = shipAddress);
        document.getElementById('pl-form-contact') && (document.getElementById('pl-form-contact').value = contact);
        if (document.getElementById('pl-form-method-sel')) { var ms = document.getElementById('pl-form-method-sel'); var mi = document.getElementById('pl-form-method'); var methods = window.itm ? window.itm() : []; if (shipMethod && methods.indexOf(shipMethod) >= 0) { ms.value = shipMethod; if (mi) mi.style.display = 'none'; } else if (shipMethod) { ms.value = '__custom__'; if (mi) { mi.style.display = ''; mi.value = shipMethod; } } }
        
        var custEl = document.getElementById('pl-form-customer');
        if (custEl) {
            var customers = window.icu();
            custEl.innerHTML = '<option value="">-- 手动输入 --</option>';
            customers.forEach(function(c) {
                var n = c.company || c.name || '';
                custEl.innerHTML += '<option value="' + n + '"' + (n === custSel ? ' selected' : '') + '>' + n + '</option>';
            });
        }
        document.getElementById('pl-form-consignee') && (document.getElementById('pl-form-consignee').value = custName);
        document.getElementById('pl-form-phone') && (document.getElementById('pl-form-phone').value = custTel);
        document.getElementById('pl-form-address') && (document.getElementById('pl-form-address').value = custAddr);
        if (custAddr) { document.getElementById('pl-form-dest') && (document.getElementById('pl-form-dest').value = parseDestination(custAddr)); }
        
        _plItems = []; _plCounter = 0;
        Object.values(piItems).filter(function(i) { return i.model_no && i.model_no.trim(); }).forEach(function(item) {
            var idx = _plCounter++;
            var model = item.model_no || '';
            var desc = item.product_name || item.description || '';
            var qty = item.qty || 0;
            var prod = window._serverProducts ? window._serverProducts.find(function(p) { return p.model === model; }) : null;
            _plItems.push({
                idx: idx, model: model, desc: desc,
                qtyCtn: prod ? (prod.packingQty || '') : '',
                cartonSize: prod ? (prod.cartonSize || '') : '',
                ctnQty: '', totalQty: qty,
                nwCtn: prod && prod.cartonWeight ? (parseFloat(prod.cartonWeight) * 0.95).toFixed(2) : '',
                gwCtn: prod ? (prod.cartonWeight || '') : '',
                ctnGroup: ''
            });
        });
        renderPLItems();
    }, 200);
}

function addPLItem() { var idx = _plCounter++; _plItems.push({idx:idx,model:'',desc:'',qtyCtn:'',cartonSize:'',ctnQty:'',totalQty:'',nwCtn:'',gwCtn:'',ctnGroup:''}); renderPLItems(); }
function removePLItem(idx) { _plItems = _plItems.filter(function(i) { return i.idx !== idx; }); renderPLItems(); }

function escHtml(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

function renderPLItems() {
    var tbody = document.getElementById('pl-items-body');
    if (!tbody) return;
    // Render group cards
    var gc = document.getElementById('pl-groups-container');
    if (gc) {
        var ghtml = '';
        _plGroups.forEach(function(gn) {
            var count = _plItems.filter(function(it) { return it.ctnGroup === gn; }).length;
            ghtml += '<div class="pl-group-card" data-group="' + gn + '" style="display:inline-flex;align-items:center;gap:4px;padding:6px 10px;background:#e0f2fe;border:2px solid #7dd3fc;border-radius:8px;cursor:pointer;font-size:0.85rem;font-weight:600;color:#0369a1;" ondragover="event.preventDefault();event.currentTarget.style.borderColor=\'#0284c7\'" ondragleave="event.currentTarget.style.borderColor=\'#7dd3fc\'" ondrop="onPLGroupDrop(event,\'' + gn + '\')">#' + gn + ' <span style="font-weight:400;color:#64748b;">(' + count + '品)</span><button onclick="removePLGroup(\'' + gn + '\')" style="background:none;border:none;color:#ef4444;cursor:pointer;font-size:14px;padding:0 2px;" title="删除编组">&times;</button></div>';
        });
        gc.innerHTML = ghtml || '<span style="color:#94a3b8;font-size:0.8rem;">暂无编组</span>';
    }
    // Populate model datalist
    var dl = document.getElementById('pl-model-suggestions');
    if (dl) {
        var products = window._serverProducts || window.ipr() || [];
        dl.innerHTML = '';
        products.forEach(function(p) { dl.innerHTML += '<option value="' + (p.model_no || p.model || '') + '">'; });
    }
    // Group counts
    var groupCounts = {};
    _plItems.forEach(function(item) { var g = item.ctnGroup || ''; if (g) groupCounts[g] = (groupCounts[g] || 0) + 1; });
    // Build items grouped: for each ctnGroup, track which indices are in it
    var html = '';
    var i = 0;
    while (i < _plItems.length) {
        var item = _plItems[i];
        var g = item.ctnGroup || '';
        var isMulti = g && groupCounts[g] > 1;
        // Find consecutive items in same group
        var groupEnd = i;
        if (g) {
            while (groupEnd + 1 < _plItems.length && _plItems[groupEnd + 1].ctnGroup === g) groupEnd++;
        }
        var groupSize = groupEnd - i + 1;
        var useRowspan = isMulti && groupSize > 1;
        var bgColor = g ? (isMulti ? '#fef2f2' : '#f0fdf4') : '';

        for (var j = i; j <= groupEnd; j++) {
            var it = _plItems[j];
            var isFirstInGroup = (j === i);
            var gwVal = '';
            var cbmVal = '';
            gwVal = (it.ctnQty && it.gwCtn) ? (parseFloat(it.ctnQty) * parseFloat(it.gwCtn)).toFixed(2) : '';
            if (it.ctnQty && it.cartonSize) {
                var dims = it.cartonSize.split('*').map(function(d) { return parseFloat(d) || 0; });
                if (dims.length >= 3) cbmVal = (dims[0] * dims[1] * dims[2] / 1000000 * parseFloat(it.ctnQty)).toFixed(4);
            }
            html += '<tr draggable="true" ondragstart="onPLDragStart(event,' + it.idx + ')" ondragover="onPLRowDragOver(event)" ondragleave="onPLRowDragLeave(event)" ondrop="onPLRowDrop(event,' + it.idx + ')" style="background:' + bgColor + ';">' +
                '<td style="padding:2px;border:1px solid #e2e8f0;text-align:center;cursor:grab;" class="pl-drag-handle">☰</td>' +
                '<td style="padding:2px;border:1px solid #e2e8f0;text-align:center;font-weight:600;font-size:11px;background:' + bgColor + ';">' + (g || '-') + '</td>' +
                '<td style="padding:2px;border:1px solid #e2e8f0;"><input value="' + (it.model||'') + '" list="pl-model-suggestions" oninput="onPLModelInput(' + it.idx + ',this.value)" onchange="onPLModelChange(' + it.idx + ',this.value)" style="width:100%;border:none;font-size:11px;background:transparent;" autocomplete="off"></td>' +
                '<td style="padding:2px;border:1px solid #e2e8f0;"><input value="' + (it.desc||'') + '" onchange="updatePLField(' + it.idx + ',\'desc\',this.value)" style="width:100%;border:none;font-size:11px;background:transparent;"></td>' +
                '<td style="padding:2px;border:1px solid #e2e8f0;"><input value="' + (it.qtyCtn||'') + '" onchange="updatePLField(' + it.idx + ',\'qtyCtn\',this.value)" style="width:55px;border:none;font-size:11px;text-align:center;background:transparent;"></td>';

            // Merge columns for multi-item group
            if (useRowspan) {
                if (isFirstInGroup) {
                    html += '<td rowspan="' + groupSize + '" style="padding:2px;border:1px solid #e2e8f0;vertical-align:middle;"><input value="' + (it.cartonSize||'') + '" onchange="updatePLGroupField(\'' + g + '\',\'cartonSize\',this.value)" style="width:70px;border:none;font-size:11px;text-align:center;background:transparent;"></td>' +
                        '<td rowspan="' + groupSize + '" style="padding:2px;border:1px solid #e2e8f0;vertical-align:middle;"><input value="' + (it.ctnQty||'') + '" onchange="updatePLGroupField(\'' + g + '\',\'ctnQty\',this.value)" style="width:55px;border:none;font-size:11px;text-align:center;background:transparent;"></td>';
                }
                html += '<td style="padding:2px;border:1px solid #e2e8f0;"><input value="' + (it.totalQty||'') + '" onchange="updatePLField(' + it.idx + ',\'totalQty\',this.value)" style="width:55px;border:none;font-size:11px;text-align:center;background:transparent;"></td>';
                if (isFirstInGroup) {
                    html += '<td rowspan="' + groupSize + '" style="padding:2px;border:1px solid #e2e8f0;vertical-align:middle;"><input value="' + (it.nwCtn||'') + '" onchange="updatePLGroupField(\'' + g + '\',\'nwCtn\',this.value)" style="width:55px;border:none;font-size:11px;text-align:center;background:transparent;"></td>' +
                        '<td rowspan="' + groupSize + '" style="padding:2px;border:1px solid #e2e8f0;vertical-align:middle;"><input value="' + (it.gwCtn||'') + '" onchange="updatePLGroupField(\'' + g + '\',\'gwCtn\',this.value)" style="width:55px;border:none;font-size:11px;text-align:center;background:transparent;"></td>' +
                        '<td rowspan="' + groupSize + '" style="padding:2px;border:1px solid #e2e8f0;text-align:center;vertical-align:middle;">' + gwVal + '</td>' +
                        '<td rowspan="' + groupSize + '" style="padding:2px;border:1px solid #e2e8f0;text-align:center;vertical-align:middle;">' + cbmVal + '</td>';
                }
            } else {
                // Normal row (no rowspan)
                html += '<td style="padding:2px;border:1px solid #e2e8f0;"><input value="' + (it.cartonSize||'') + '" onchange="updatePLField(' + it.idx + ',\'cartonSize\',this.value)" style="width:70px;border:none;font-size:11px;text-align:center;background:transparent;"></td>' +
                    '<td style="padding:2px;border:1px solid #e2e8f0;"><input value="' + (it.ctnQty||'') + '" onchange="updatePLCTNQty(' + it.idx + ',this.value)" style="width:55px;border:none;font-size:11px;text-align:center;background:transparent;"></td>' +
                    '<td style="padding:2px;border:1px solid #e2e8f0;text-align:center;font-size:11px;">' + ((parseInt(it.qtyCtn)||0) * (parseInt(it.ctnQty)||0) || '') + '</td>' +
                    '<td style="padding:2px;border:1px solid #e2e8f0;"><input value="' + (it.nwCtn||'') + '" onchange="updatePLField(' + it.idx + ',\'nwCtn\',this.value)" style="width:55px;border:none;font-size:11px;text-align:center;background:transparent;"></td>' +
                    '<td style="padding:2px;border:1px solid #e2e8f0;"><input value="' + (it.gwCtn||'') + '" onchange="updatePLField(' + it.idx + ',\'gwCtn\',this.value)" style="width:55px;border:none;font-size:11px;text-align:center;background:transparent;"></td>' +
                    '<td style="padding:2px;border:1px solid #e2e8f0;text-align:center;font-size:11px;">' + gwVal + '</td>' +
                    '<td style="padding:2px;border:1px solid #e2e8f0;text-align:center;font-size:11px;">' + cbmVal + '</td>';
            }
            html += '<td style="padding:2px;border:1px solid #e2e8f0;text-align:center;"><button onclick="removePLItem(' + it.idx + ')" style="background:none;border:none;color:#ef4444;cursor:pointer;font-size:14px;">&times;</button></td>' +
                '</tr>';
        }
        i = groupEnd + 1;
    }
    tbody.innerHTML = html;
}

function updatePLCTN(idx, val) { var it = _plItems.find(function(i){return i.idx===idx}); if(it) { it.ctnGroup = val; if (val && _plGroups.indexOf(val) < 0) _plGroups.push(val); var gc=0; _plItems.forEach(function(x){if(x.ctnGroup===val)gc++;}); if(gc>=2) _plItems.forEach(function(x){if(x.ctnGroup===val){x.cartonSize='';x.ctnQty='';x.nwCtn='';x.gwCtn='';}}); sortPLItems(); } renderPLItems(); }
function updatePLCTNQty(idx, val) { var it = _plItems.find(function(i){return i.idx===idx}); if(it) it.ctnQty = val; renderPLItems(); }

function onPLHeaderSelect() {
    var h = window.ih().find(function(x) { return x.name === document.getElementById('pl-form-header').value; });
    if (!h) return;
    document.getElementById('pl-form-company').value = h.company_name || '';
    document.getElementById('pl-form-shipper').value = h.shipper || '';
    document.getElementById('pl-form-ship-phone').value = h.ship_phone || '';
    document.getElementById('pl-form-ship-address').value = h.ship_address || '';
    document.getElementById('pl-form-contact').value = h.contact || '';
}

function onPLCustomerSelect() {
    var selVal = document.getElementById('pl-form-customer').value;
    var c = window.icu().find(function(x) { return (x.name||x.company) === selVal; });
    if (!c) return;
    document.getElementById('pl-form-consignee').value = c.name || c.company || '';
    document.getElementById('pl-form-phone').value = c.tel || '';
    document.getElementById('pl-form-address').value = c.address || '';
    if (c.address) { document.getElementById('pl-form-dest').value = parseDestination(c.address); }
}
function parseDestination(addr) {
    if (!addr) return '';
    addr = String(addr).trim();
    if (/china|中国|北京|上海|天津|重庆|河北|山西|辽宁|吉林|黑龙江|江苏|浙江|安徽|福建|江西|山东|河南|湖北|湖南|广东|海南|四川|贵州|云南|陕西|甘肃|青海|台湾|内蒙古|广西|西藏|宁夏|新疆|香港|澳门/i.test(addr)) {
        var cm = addr.match(/([一-龥]{2,}(?:市|区|县|州))/);
        if (cm) return cm[1];
        return 'China';
    }
    var cnMap = { '日本':'Japan','韩国':'Korea','美国':'USA','德国':'Germany','法国':'France','英国':'UK','意大利':'Italy','西班牙':'Spain','荷兰':'Netherlands','澳大利亚':'Australia','加拿大':'Canada','巴西':'Brazil','印度':'India','俄罗斯':'Russia','泰国':'Thailand','越南':'Vietnam','印尼':'Indonesia','马来西亚':'Malaysia','新加坡':'Singapore','阿联酋':'UAE','沙特':'Saudi Arabia','菲律宾':'Philippines','墨西哥':'Mexico','土耳其':'Turkey','比利时':'Belgium' };
    for (var k in cnMap) { if (addr.indexOf(k) >= 0) return cnMap[k]; }
    var countries = ['United States','USA','Germany','France','UK','United Kingdom','Italy','Spain','Netherlands','Belgium','Japan','Korea','Australia','Canada','Brazil','Mexico','India','Russia','Turkey','UAE','Singapore','Thailand','Vietnam','Indonesia','Malaysia','Philippines','Saudi Arabia'];
    for (var ci = 0; ci < countries.length; ci++) { if (addr.toLowerCase().indexOf(countries[ci].toLowerCase()) >= 0) return countries[ci]; }
    return '';
}
function initPLHeaders() {
    var sel = document.getElementById('pl-form-header');
    if (!sel) return;
    var cv = sel.value;
    sel.innerHTML = '<option value="">-- 手动输入 --</option>';
    window.ih().forEach(function(h) { sel.innerHTML += '<option value="' + h.name + '">' + h.name + '</option>'; });
    sel.value = cv;
}

function initPLCustomers() {
    var dl = document.getElementById("pl-customer-suggestions");
    if (!dl) return;
    var t = (window.Auth && Auth.getToken) ? Auth.getToken() : "";
    fetch("/api/customers", { headers: { "Authorization": "Bearer " + t } }).then(function(r) { return r.json(); }).then(function(res) {
        var allCusts = Array.isArray(res) ? res : (res.customers || []);
        var opts = "", seen = {};
        allCusts.forEach(function(c) {
            var n = c.contact || "";
            if (n && !seen[n]) { seen[n] = true; opts += "<option value=\"" + n + "\">"; }
        });
        dl.innerHTML = opts;
    }).catch(function(e) {});
}

function isDownloadPL() {
    if (!_plLastBlob) { sT('请先生成 Packing List', 'warning'); return; }
    var url = URL.createObjectURL(_plLastBlob);
    var a = document.createElement('a'); a.href = url;
    a.download = 'Packing_List_' + (isV('pl-form-no') || 'export') + '.xlsx';
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    URL.revokeObjectURL(url); sT('下载成功', 'success');
}

async function isGeneratePLExcel() {
    if (!_plItems.length) { sT('请至少添加一个产品行', 'error'); return; }
    var data = {
        plNo: isV('pl-form-no'), date: isV('pl-form-date'), method: isV('pl-form-method'), dest: isV('pl-form-dest'),
        company: isV('pl-form-company'), contact: isV('pl-form-contact'),
        shipper: isV('pl-form-shipper'), shipPhone: isV('pl-form-ship-phone'), shipAddr: isV('pl-form-ship-address'),
        consignee: isV('pl-form-consignee'), phone: isV('pl-form-phone'), address: isV('pl-form-address'),
        mark: isV('pl-form-mark'), items: JSON.parse(JSON.stringify(_plItems))
    };
    try {
        var resp = await fetch('/api/template/packinglist');
        var wb = new window.ExcelJS.Workbook();
        await wb.xlsx.load(await resp.arrayBuffer());
        var ws = wb.getWorksheet(1);
        if (data.company) ws.getCell('A2').value = data.company.toUpperCase();
        ws.getCell('L2').value = 'PACKING LIST';
        if (data.contact) ws.getCell('A3').value = data.contact;
        ws.getCell('I3').value = 'Direct Factory. CE//RoHS/REACH Certified';
        ws.getCell('B6').value = (data.shipper ? data.shipper + ', ' : '') + (data.shipPhone || '');
        ws.getCell('J6').value = data.plNo || '';
        ws.getCell('B7').value = data.shipAddr || '';
        ws.getCell('J7').value = data.date || '';
        ws.getCell('B8').value = (data.consignee ? data.consignee + ', ' : '') + (data.phone || '');
        ws.getCell('J8').value = data.method || '';
        ws.getCell('B9').value = data.address || '';
        ws.getCell('J9').value = data.dest || '';

        ['A12:A14','B12:B13','F12:F13','G12:G13','H12:H13','I12:I13','J12:J13','K12:K13','L12:L13'].forEach(function(m) { try { ws.unMergeCells(m); } catch(e) {} });
        var itemCount = data.items.length;
        var insertCount = Math.max(0, itemCount - 3);
        for (var r = 0; r < insertCount; r++) ws.spliceRows(13, 0, 1);
        var styleRow = ws.getRow(12);
        for (var i = 1; i < itemCount; i++) {
            var row = ws.getRow(12 + i);
            styleRow.eachCell({includeEmpty:true}, function(cell, cn) { try { row.getCell(cn).style = JSON.parse(JSON.stringify(cell.style)); } catch(e) {} });
            row.height = styleRow.height;
        }
        var ctnGroups = {};
        data.items.forEach(function(item) {
            var ctn = (item.ctnGroup || '').trim();
            if (ctn) { if (!ctnGroups[ctn]) ctnGroups[ctn] = []; ctnGroups[ctn].push(item); }
        });
        var multiCTN = {};
        // Nuke all existing merges in product area to avoid 'already merged' errors
        var allMerges = ws.model.merges || [];
        if (Array.isArray(allMerges)) {
            allMerges.forEach(function(m) {
                var parts = typeof m === 'string' ? m.split(':') : [];
                if (parts.length === 2) {
                    var topRow = parseInt(parts[0].replace(/[A-Z]/g, ''));
                    var botRow = parseInt(parts[1].replace(/[A-Z]/g, ''));
                    if (topRow >= 12 && topRow <= 12 + itemCount + 5) {
                        try { ws.unMergeCells(m); } catch(e) {}
                    }
                }
            });
        }
                Object.keys(ctnGroups).forEach(function(ctn) { if (ctnGroups[ctn].length > 1) multiCTN[ctn] = true; });
        var idxToRow = {};
        data.items.forEach(function(item, i) { idxToRow[item.idx] = 12 + i; });
        data.items.forEach(function(item, i) {
            var rn = 12 + i;
            ws.getCell('A' + rn).value = data.mark || '';
            if (item.ctnGroup) ws.getCell('B' + rn).value = item.ctnGroup;
            ws.getCell('C' + rn).value = item.model || '';
            ws.getCell('D' + rn).value = item.desc || '';
            var isCtnChild = item.ctnGroup && multiCTN[item.ctnGroup] && ctnGroups[item.ctnGroup][0].idx !== item.idx;
            if (!isCtnChild) {
                if (item.ctnQty) ws.getCell('G' + rn).value = parseInt(item.ctnQty) || 0;
                if (item.qtyCtn) ws.getCell('E' + rn).value = item.qtyCtn;
                if (item.cartonSize) ws.getCell('F' + rn).value = item.cartonSize;
            }
                        var _inMulti = item.ctnGroup && multiCTN[item.ctnGroup];
            if (_inMulti) {
                if (item.totalQty) ws.getCell('H' + rn).value = parseInt(item.totalQty) || 0;
            } else {
                var _tq = (parseInt(item.qtyCtn) || 0) * (parseInt(item.ctnQty) || 0);
                if (_tq) ws.getCell('H' + rn).value = _tq;
            }
            if (!isCtnChild) {
                if (item.nwCtn) ws.getCell('I' + rn).value = parseFloat(item.nwCtn) || 0;
                if (item.gwCtn) ws.getCell('J' + rn).value = parseFloat(item.gwCtn) || 0;
            }
            var isMultiGroup = item.ctnGroup && multiCTN[item.ctnGroup];
            if (isMultiGroup && isCtnChild) {
                // Child rows in multi-group: K/L merged, skip
            } else if (isMultiGroup) {
                // First row in multi-group: compute plain values from shared fields
                var gw = parseFloat(item.gwCtn) || 0;
                var cq = parseFloat(item.ctnQty) || 0;
                ws.getCell('K' + rn).value = gw * cq;
                var csM = item.cartonSize;
                if (csM) {
                    var dms = csM.split('*').map(function(d) { return parseFloat(d) || 0; });
                    if (dms.length >= 3) ws.getCell('L' + rn).value = cq * dms[0] * dms[1] * dms[2] / 1000000;
                }
            } else {
                // Single-item rows: use formulas
                ws.getCell('K' + rn).value = { formula: 'J' + rn + '*G' + rn };
                var csS = item.cartonSize;
                if (csS) {
                    var dms2 = csS.split('*').map(function(d) { return parseFloat(d) || 0; });
                    if (dms2.length >= 3) {
                        ws.getCell('L' + rn).value = { formula: 'G' + rn + '*' + dms2[0] + '*' + dms2[1] + '*' + dms2[2] + '/1000000' };
                    } else {
                        ws.getCell('L' + rn).value = { formula: 'G' + rn + '*45*35*30/1000000' };
                    }
                } else {
                    ws.getCell('L' + rn).value = { formula: 'G' + rn + '*45*35*30/1000000' };
                }
            }
        });
        if (itemCount > 1) ws.mergeCells('A12:A' + (11 + itemCount));
        Object.keys(ctnGroups).forEach(function(ctn) {
            var group = ctnGroups[ctn];
            if (group.length > 1) {
                var rows = group.map(function(g) { return idxToRow[g.idx]; }).sort(function(a,b){ return a - b; });
                var segStart = rows[0], segEnd = rows[0];
                for (var ri = 1; ri < rows.length; ri++) {
                    if (rows[ri] === segEnd + 1) { segEnd = rows[ri]; }
                    else { if (segEnd > segStart) { ['B','F','G','I','J','K','L'].forEach(function(c){ try{ws.unMergeCells(c+segStart+':'+c+segEnd);}catch(e){} ws.mergeCells(c+segStart+':'+c+segEnd); }); } segStart = rows[ri]; segEnd = rows[ri]; }
                }
                if (segEnd > segStart) { ['B','F','G','I','J','K','L'].forEach(function(c){ try{ws.unMergeCells(c+segStart+':'+c+segEnd);}catch(e){} ws.mergeCells(c+segStart+':'+c+segEnd); }); }
            }
        });
        // Set Total row SUM formulas for G (CTN Qty), K (Tot G.W.), L (CBM)
        var totalRow = 15 + insertCount;
        ws.getCell('G' + totalRow).value = { formula: 'SUM(G12:G' + (11 + itemCount) + ')' };
        ws.getCell('K' + totalRow).value = { formula: 'SUM(K12:K' + (11 + itemCount) + ')' };
        ws.getCell('L' + totalRow).value = { formula: 'SUM(L12:L' + (11 + itemCount) + ')' };
        var smry = 18 + insertCount;
        for (var si = 0; si < 5; si++) {
            var sr = smry + si;
            try {
                var dv = ws.getCell('D' + sr).value;
                for (var sc = 5; sc <= 12; sc++) { if (sc !== 7) try { ws.getCell(String.fromCharCode(64+sc) + sr).value = null; } catch(e) {} }
                try { ws.unMergeCells('D' + sr + ':L' + sr); } catch(e) {}
                ws.mergeCells('D' + sr + ':L' + sr);
                if (dv) ws.getCell('D' + sr).value = dv;
            } catch(e) {}
        }
        try { ws.getCell('D' + (smry)).value = { formula: 'G' + totalRow + ' & " Cartons (箱)"' }; } catch(e) {}
        try { ws.getCell('D' + (smry+1)).value = { formula: 'ROUND(K' + totalRow + ', 2) & " KGS (公斤)"' }; } catch(e) {}
        try { ws.getCell('D' + (smry+2)).value = { formula: 'ROUND(L' + totalRow + ', 2) & " CBM (立方米)"' }; } catch(e) {}
        var blob = await wb.xlsx.writeBuffer();
        _plLastBlob = new Blob([blob], {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var url = URL.createObjectURL(_plLastBlob);
        var a = document.createElement('a'); a.href = url;
        a.download = 'Packing_List_' + (data.plNo || 'export') + '.xlsx';
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        URL.revokeObjectURL(url);
        var dl = document.getElementById('pl-dl-btn'); if (dl) dl.disabled = false;
        sT('Packing List 生成成功，已下载', 'success');
    } catch(e) { sT('生成失败: ' + e.message, 'error'); console.error(e); }
}

function loadAiApiSettings() {
  var baseEl = document.getElementById('ai-api-base');
  var keyEl = document.getElementById('ai-api-key');
  var modelEl = document.getElementById('ai-model');
  var promptEl = document.getElementById('system-prompt');
  Auth.apiFetch('/api/settings').then(function(settings) {
    if (settings.aiApiBase && baseEl) baseEl.value = settings.aiApiBase;
    if (settings.aiApiKey && keyEl) keyEl.value = settings.aiApiKey;
    if (settings.aiModel && modelEl) modelEl.value = settings.aiModel;
    if (settings.embedApiBase && embedBaseEl) embedBaseEl.value = settings.embedApiBase;
    if (settings.embedModel && embedModelEl) embedModelEl.value = settings.embedModel;
    if (settings.embedApiKey && embedKeyEl) embedKeyEl.value = settings.embedApiKey;
    if (settings.systemPromptOverride && promptEl) promptEl.value = settings.systemPromptOverride;
  }).catch(function() {});
}
function saveAiApiSettings() {
  var base = document.getElementById('ai-api-base').value.trim();
  var key = document.getElementById('ai-api-key').value.trim();
  var model = document.getElementById('ai-model') ? document.getElementById('ai-model').value : '';
  var promptEl = document.getElementById('system-prompt');
  var prompt = promptEl ? promptEl.value : '';
  Auth.apiFetch('/api/settings').then(function(current) {
    if (key) { current.aiApiBase = base || 'https://api.deepseek.com'; current.aiApiKey = key; }
    if (model) { current.aiModel = model; }
    current.systemPromptOverride = prompt;
    return Auth.apiFetch('/api/settings', { method: 'PUT', body: JSON.stringify(current) });
  }).then(function() { sT('配置已保存，全局生效', 'success'); showAiApiStatus('connected', 'API Key 已配置'); })
    .catch(function(e) { sT('保存失败: ' + e.message, 'error'); });
}

function testAiApiConnection() {
  var key = document.getElementById('ai-api-key').value.trim();
  if (!key) { sT('请先输入 API Key', 'error'); return; }
  var statusEl = document.getElementById('ai-api-status');
  statusEl.style.display = 'block';
  statusEl.style.background = '#fef3c7';
  statusEl.style.color = '#92400e';
  statusEl.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> 正在测试连接...';
  var base = document.getElementById('ai-api-base').value.trim() || 'https://api.deepseek.com';
  fetch(base + '/v1/models', { headers: { 'Authorization': 'Bearer ' + key } })
    .then(function(r) {
      if (r.ok) { showAiApiStatus('connected', '<i class="fa-solid fa-circle-check"></i> 连接成功！DeepSeek API 可用'); }
      else { showAiApiStatus('error', '<i class="fa-solid fa-circle-xmark"></i> 连接失败：请检查 API Key 和接口地址'); }
    })
    .catch(function() { showAiApiStatus('error', '<i class="fa-solid fa-circle-xmark"></i> 无法连接：请检查网络和接口地址'); });
}
function showAiApiStatus(type, msg) {
  var el = document.getElementById('ai-api-status');
  if (!el) return;
  el.style.display = 'block';
  if (type === 'connected') { el.style.background = '#d1fae5'; el.style.color = '#065f46'; }
  else { el.style.background = '#fee2e2'; el.style.color = '#991b1b'; }
  el.innerHTML = msg;
}
window.loadKBIndexStatus = loadKBIndexStatus;
// Auto-load on settings page
setTimeout(function() { if (document.getElementById('kb-index-status')) loadKBIndexStatus(); }, 500);


// ===== CTN Group Management =====
function addPLGroup() {
    var input = document.getElementById('pl-group-input');
    var name = (input ? input.value.trim() : '') || ('CTN' + (_plGroups.length + 1));
    if (_plGroups.indexOf(name) >= 0) { sT('编组 "' + name + '" 已存在', 'warning'); return; }
    _plGroups.push(name);
    if (input) input.value = '';
    renderPLItems();
}
function removePLGroup(name) {
    _plGroups = _plGroups.filter(function(g) { return g !== name; });
    _plItems.forEach(function(item) { if (item.ctnGroup === name) item.ctnGroup = ''; });
    renderPLItems();
}
function onPLDragStart(ev, idx) {
    ev.dataTransfer.setData('text/plain', String(idx));
    ev.dataTransfer.effectAllowed = 'move';
}
function onPLGroupDrop(ev, groupName) {
    ev.preventDefault();
    ev.currentTarget.style.borderColor = '#7dd3fc';
    var idx = parseInt(ev.dataTransfer.getData('text/plain'));
    if (isNaN(idx)) return;
    var item = _plItems.find(function(i) { return i.idx === idx; });
    if (!item) return;
    item.ctnGroup = groupName;
    renderPLItems();
}
function updatePLField(idx, field, val) {
    var item = _plItems.find(function(i) { return i.idx === idx; });
    if (!item) return;
    item[field] = val;
    if (field === 'gwCtn' && val) { item.nwCtn = (parseFloat(val) * 0.95).toFixed(2); }
    renderPLItems();
}
window.addPLGroup = addPLGroup;
window.removePLGroup = removePLGroup;
window.onPLDragStart = onPLDragStart;
window.onPLGroupDrop = onPLGroupDrop;
window.updatePLField = updatePLField;


function initPLMethods() {
    var sel = document.getElementById('pl-form-method-sel');
    if (!sel) return;
    var cv = sel.value;
    sel.innerHTML = '<option value="">-- 手动输入 --</option>';
    var methods = window.itm ? window.itm() : [];
    methods.forEach(function(m) { sel.innerHTML += '<option value="' + m + '">' + m + '</option>'; });
    sel.innerHTML += '<option value="__custom__">-- 自定义 --</option>';
    sel.value = cv;
}
function onPLMethodChange() {
    var sel = document.getElementById('pl-form-method-sel');
    var input = document.getElementById('pl-form-method');
    if (!sel || !input) return;
    if (sel.value === '__custom__') { input.style.display = ''; input.value = ''; }
    else { input.style.display = 'none'; input.value = sel.value; }
}
window.initPLMethods = initPLMethods;
window.onPLMethodChange = onPLMethodChange;

function onPLModelInput(idx, val) {
    var it = _plItems.find(function(i) { return i.idx === idx; });
    if (!it) return;
    // Force re-render so datalist shows matching options
}
function onPLModelChange(idx, val) {
    var it = _plItems.find(function(i) { return i.idx === idx; });
    if (!it) return;
    it.model = val;
    // Auto-fill from product database
    var prod = null;
    if (window._serverProducts) prod = window._serverProducts.find(function(p) { return (p.model||p.model_no) === val; });
    if (!prod) { var pr = window.ipr ? window.ipr() : []; prod = pr.find(function(p) { return p.model_no === val; }); }
    if (prod) {
        it.desc = prod.productName || prod.product_name || prod.name || it.desc || '';
        it.qtyCtn = prod.packingQty || it.qtyCtn || '';
        it.cartonSize = (prod.cartonSize || '').replace(/cm$/i, '').trim() || it.cartonSize || '';
        it.nwCtn = prod.cartonWeight ? (parseFloat(prod.cartonWeight) * 0.95).toFixed(2) : it.nwCtn || '';
        it.gwCtn = prod.cartonWeight || it.gwCtn || '';
    }
    renderPLItems();
}
function updatePLGroupField(groupName, field, val) {
    _plItems.forEach(function(it) {
        if (it.ctnGroup === groupName) { it[field] = val; if (field === 'gwCtn' && val) { it.nwCtn = (parseFloat(val) * 0.95).toFixed(2); } }
    });
    renderPLItems();
}
// Drag-drop for row reordering
var _plDragOverRow = null;
function onPLRowDragOver(ev) { ev.preventDefault(); _plDragOverRow = ev.currentTarget; ev.currentTarget.style.borderTop = '2px solid #3b82f6'; }
function onPLRowDragLeave(ev) { ev.currentTarget.style.borderTop = ''; }
function onPLRowDrop(ev, targetIdx) {
    ev.preventDefault();
    if (_plDragOverRow) _plDragOverRow.style.borderTop = '';
    var srcIdx = parseInt(ev.dataTransfer.getData('text/plain'));
    if (isNaN(srcIdx) || srcIdx === targetIdx) return;
    var srcPos = -1, tgtPos = -1;
    for (var i = 0; i < _plItems.length; i++) {
        if (_plItems[i].idx === srcIdx) srcPos = i;
        if (_plItems[i].idx === targetIdx) tgtPos = i;
    }
    if (srcPos >= 0 && tgtPos >= 0) {
        var item = _plItems.splice(srcPos, 1)[0];
        if (srcPos < tgtPos) tgtPos--;
        _plItems.splice(tgtPos, 0, item);
    }
    renderPLItems();
}
window.onPLModelInput = onPLModelInput;
window.onPLModelChange = onPLModelChange;
window.updatePLGroupField = updatePLGroupField;
window.onPLRowDragOver = onPLRowDragOver;
window.onPLRowDragLeave = onPLRowDragLeave;
window.onPLRowDrop = onPLRowDrop;

function sortPLItems() {
    // Group items by ctnGroup, keep ungrouped at end, preserve relative order within groups
    var grouped = [];
    var ungrouped = [];
    var seen = {};
    _plItems.forEach(function(item) {
        var g = item.ctnGroup || '';
        if (g) {
            if (!seen[g]) seen[g] = [];
            seen[g].push(item);
        } else {
            ungrouped.push(item);
        }
    });
    Object.keys(seen).forEach(function(g) { grouped = grouped.concat(seen[g]); });
    _plItems = grouped.concat(ungrouped);
}
window.sortPLItems = sortPLItems;
window._plItems = _plItems;
window.isGeneratePL = isGeneratePL;
window.addPLItem = addPLItem;
window.removePLItem = removePLItem;
window.onPLHeaderSelect = onPLHeaderSelect;
window.onPLCustomerSelect = onPLCustomerSelect;
window.isGeneratePLExcel = isGeneratePLExcel;
window.isDownloadPL = isDownloadPL;
window.parseDestination = parseDestination;
window.updatePLCTN = updatePLCTN;
window.updatePLCTNQty = updatePLCTNQty;
window.loadAiApiSettings = loadAiApiSettings;
window.saveAiApiSettings = saveAiApiSettings;
window.testAiApiConnection = testAiApiConnection;
export { openInvoiceBuilder, renderInvoiceForm, initInvoiceCenter, updateTopBarRate, refreshAllIsLists, refreshHeaderSelect, refreshIsDropdowns, refreshIsRate, refreshPaymentSelect };
